/** @format */

const en = {
  eventLinks: {
    title: "Links",
    webApp: "Web application for attendees",
    iosApp: "Mobile application for attendees (IOS)",
    androidApp: "Mobile application for attendees (Android)"
  },
  datetime: {
    setTime: "Specify the time.",
    setDate: "Specify the date."
  },
  eventPageTitle: {
    eventHome: "Event home",
    aboutEvent: "Event details",
    dashboard: "Event dashboard",
    search: "Find records",
    participants: "Attendees",
    segmentation: "Segmentation",
    paymentsAndConfirmation: "Payments & Confirmations",
    registrationForms: "Registrations form",
    speakers: "Speakers",
    eventProgram: "Event program",
    sponsors: "Sponsors",
    expo: "Expo",
    networking: "Networking Areas",
    album: "Album",
    documentsAndFiles: "Documents & Files",
    faq: "F.A.Q",
    maps: "Maps",
    liveSessions: "Live sessions",
    automatedMessages: "Automated messages",
    certificates: "Certificates",
    cardDesign: "Card designs",
    controlPoint: "Control points",
    promotions: "Promotions",
    events: "Events",
    organisation: "Organisation",
    organisationOverview: "Overview",
    organisationTeam: "Team",
    organisationProfile: "Profile",
    organisationIntegrations: "Integrations",
    organisationBilling: "Billing"
  },
  eventCopy: {
    copyEvent: "Copy event",
    eventTitle: "Event name",
    eventCopyType: "Select the records you want to copy",
    eventCopyTitle: "Copying to {0}",
    selectAll: "Select all",
    eventArchive: "Archive event",
    unarchive: "Unarchive"
  },
  myOwnEvents: {
    title: "Events you manage",
    event: "Event",
    dateVanue: "Date / Venue"
  },
  placeholder: {
    search: "Search..."
  },
  validation: {
    plsFillThisField: "Please fill this field.",
    plsCheckThisField: "Please check wrong fields."
  },
  dotDay: ".Day",
  dotSaloon: ".Hall",
  minMinutes: "min",
  buttonGeneral: {
    searchFilter: "Search / Filter",
    show: "Show",
    delete: "Delete",
    edit: "Edit",
    remove: "Remove",
    add: "Add",
    refresh: "Refresh",
    loading: "Loading...",
    notPublished: "It hasn't been published yet."
  },

  confirmation: {
    couponCode: "Coupon Code",
    couponCodeMsg: "If you have a code that you can use in your current selections, do not forget to apply it.",
    button: {
      apply: "Apply",
      remove: "Remove"
    },
    selectCode: "Enter code here"
  },
  abstract: {
    authorSettings: {
      firstNameTitle: "First Name",
      lastNameTitle: "Last Name",
      emailTitle: "E-Mail",
      phoneTitle: "Phone",
      institutionTitle: "Institution",
      countryTitle: "Country",
      stateTitle: "State",
      cityTitle: "City"
    }
  },
  summaryComponent: {
    free: "Free",
    "payment-information": "Payment information",
    "payment-id": "Payment ID",
    date: "Date",
    "payment-type": "Payment type",
    "bank-transfer": "Bank transfer",
    "registration-form": "Registiration form",
    "event-registration-form": "Event registration form",
    "coupon-code": "Coupon code",
    amount: "Amount",
    situation: "Status",
    "waiting-for-approval": "Waiting for approval",
    "payment-pending": "Payment pending",
    approved: "Approved",
    denied: "Rejected",
    "transaction-wait-msg": "Your registration is completed. When your transaction is approved, you will be receive a notification e-mail.",
    "transaction-information": "Customer Information",
    edit: "Edit",
    "performer-transaction-name": "Name:",
    "phone-number": "Phone",
    "e-mail": "Email",
    "invoice-receipt-info": "Invoice / Receipt information",
    type: "Type",
    institutional: "Institutional",
    "official-title": "Official title",
    "tax-no": "Tax Number",
    "tax-administration": "Tax Administration",
    address: "Address",
    records: "Attendees",
    voucher: "Voucher",
    "registration-information": "Registration information",
    companions: "Companions",
    "additional-service": "Additional services",
    abstract: "Abstract",
    "transaction-note": "Transaction note",
    service: "Services",
    "product-service": "Product / Service",
    "unit-price": "Unit price",
    quantity: "Quantity",
    subtotal: "Subtotal",
    discounts: "Discount",
    taxes: "Taxes",
    total: "Total",
    "bank-information": "Bank information",
    "bank-information-no-msg": "Bank information is not available."
  },
  auth: {
    errorList: {
      badGateway: "Bad Gateway",
      badGatewayDesc: "We apologize for the situation you experienced. The system is currently under maintenance and will be available as soon as possible. You can reach us at <a href='mailto:support@holacon.com'>support@holacon.com</a>. Thank you for your understanding."
    },
    forgotPassword: {
      resend: "Resend mail",
      title: "Forgot Password",
      forgotDesc: "Enter your account e-mail to start the password resetting process. Password resetting steps will be sent to this e-mail address.",
      forgotDescEnterCode: "Please ensure the accuracy of the code specified in your email address and fill in the password and confirm password fields.",
      email: "E-mail",
      resetKey: "Reset key",
      password: "Password",
      repassword: "Retype password",
      reset: "Reset"
    },
    login: {
      login: "Login",
      email: "E-mail",
      password: "Password",
      placeholderEmail: "Example : example@example.com",
      placeholderPassword: "Account Password",
      forgotPassword: "Forgot Password",
      existAccount: "Don't have an account yet?",
      createAccount: "Create a new account now."
    },
    register: {
      register: "Register",
      registerText: "Fill in the required fields to register in the management console.",
      firstName: "First Name",
      lastName: "Last Name",
      email: "E-mail",
      password: "Password",
      repassword: "Retype password",
      userAgreement: "I have read and accepted the user agreement",
      gdprAgreement: "I have read the GDPR Enlightenment text, and I approve.",
      onlineInterview: "Online interview express consent confirmation",
      distancePolicy: "distance sales contract",
      privacyPolicy: "I have read and accepted the privacy policy",
      subscriptionPolicy: "subscription agreement",
      readApprove: "I read and agree.",
      existAccount: "Do you have an account?",
      invitationCode: "Invitation Code",
      invitationCodeText: "You can leave this blank if you don't have an invitation code.",
      cancel: "Cancel",
      accept: "Accept",
      agreement: {
        userTitle: "User Agreement"
      }
    }
  },
  event: {
    helpful: {
      title: "Tools"
    },
    participantManagament: {
      title: "Attendee management"
    },

    menu: {
      eventstart: {
        title: "Start"
      },

      eventhome: {
        title: "Event details",
        searchterms: ["event information", "event logo", "event cover photo", "about event", "registration screen", "registration banner", "sub-event", "online payment", "virtual pos", "wire transfer", "eft", "social media", "voucher", "application modules", "mobile application", "module", "contact information", "settings", "automatic check-in", "activate registration screen", "networking features", "currency", "address", "event location", "event color", "publish event", "enpublish event"]
      },

      reports: {
        title: "Dashboard & Reports",
        searchterms: ["reports", "check-in records", "check-in reports", "check-in", "check-in reports", "registration reports", "sales reports", "report", "dashboard"]
      },

      salesregistrations: {
        title: "Registration & Sales"
      },

      registrationsearch: {
        title: "Registration search",
        searchterms: ["print badge", "check-in", "check-in", "registration query", "registration search"]
      },

      participants: {
        title: "Attendee list",
        searchterms: ["attendee list", "attendee search", "attendee query", "send voucher", "send sms", "add proxy", "edit registration", "delete registration", "block attendee", "transfer registration", "bulk checkin", "bulk check-in", "bulk delete registration", "bulk delete registration", "send bulk voucher", "send bulk sms", "registration list", "add registration", "add attendee", "create registration", "create attendee"]
      },

      registrationmanagement: {
        title: "Registration management",
        searchterms: []
      },

      registrationforms: {
        title: "Registration forms",
        searchterms: ["online registration form", "registration form", "registration form field", "custom registration form", "registration form customization", "online registration", "event registration form", "registration form data", "registration form input"]
      },
      additionalProduct: {
        title: "Products",
        searchterms: ["online kayit formu", "kayit formu", "kayit formu alan", "ozel kayit formu", "kayif formu ozellestirme", "online kayit", "etkinlik kayit formu", "kayit form verisi", "kayit formu input"]
      },

      registrationgroups: {
        title: "Groups",
        searchterms: ["grups", "attendee groups", "registration groups", "tag groups"]
      },

      registrationtags: {
        title: "Segmentations",
        searchterms: ["tags", "attendee tags", "registration tags", "attendee segmentation", "registration segmentation", "segmentation"]
      },

      registrationpackages: {
        title: "Sales packages",
        searchterms: ["sales packages", "registration packages", "packages", "event registration", "sales and registration packages", "registration type", "registration"]
      },

      couponcodes: {
        title: "Coupon codes",
        searchterms: ["discount coupons", "coupon codes", "coupon", "create coupon", "coupon code", "create coupon code", "free coupon code", "discount", "discount code", "kayit linki", "custom registration link", "staff registration link", "code list"]
      },

      salesconfirmations: {
        title: "Sales & Confirmations",
        searchterms: ["sales", "accreditation", "payments", "registrations", "online registrations", "online payments", "online payment records", "registration confirmation", "registration confirmations", "confirmation", "sales packages", "event sales", "registration accreditation", "online accreditation", "online registrations"]
      },

      subeventregistrations: {
        title: "Sub-events",
        searchterms: ["sub-event", "subevent registration", "program registration", "registration"]
      },

      eventstore: {
        title: "Sub-events",
        searchterms: ["sub-event", "subevent registration", "program registration", "registration", "products", "add product", "edit product", "create product", "product category", "product category", "add product category", "create product category", "edit product category", "product prices", "product sales", "product sale list", "product sales report", "product sales reports", "event products", "event product sale"]
      },

      accomodation: {
        title: "Accommodation & Transfer",
        searchterms: [
          "hotel",
          "room",
          "room type",
          "accommodation",
          "add hotel",
          "create hotel",
          "edit hotel",
          "add room",
          "create room",
          "edit room",
          "accommodation list",
          "accommodation reports",
          "add room type",
          "edit room type",
          "create room type",
          "transfer",
          "private transfer",
          "vip transfer",
          "transfer report",
          "transfers",
          "transfer list",
          "driver",
          "driver information",
          "edit driver",
          "route",
          "routes",
          "create route",
          "add route",
          "edit route",
          "pick-up points",
          "transfer vehicles",
          "add transfer vehicle",
          "create transfer vehicle",
          "edit transfer vehicle"
        ]
      },

      abstract: {
        title: "Abstract management",
        searchterms: ["abstract", "abstract module", "abstract list", "abstract form", "abstract forms", "abstract eliminations", "jury", "abstract jury", "evaluator", "abstract evaluator", "add jury", "add evaluator", "abstract dates", "evaluation dates", "abstract eliminations", "eliminations"]
      },

      contentsmoderation: {
        title: "Contents & Moderation",
        contentsManagement: {
          session: "Session"
        }
      },

      cms: {
        title: "Content management",
        searchterms: []
      },

      speakers: {
        title: "Speakers",
        searchterms: ["speakers", "speaker list", "add speaker", "edit speaker", "speaker"]
      },

      program: {
        title: "Event program",
        searchterms: ["event program", "program", "program flow", "conference program", "event flow", "congress program", "event days", "event halls", "conference halls", "program reminder", "program alarm", "program announcement", "create event program", "add event program", "create program", "add program", "edit program", "edit event program"]
      },

      sponsors: {
        title: "Sponsors",
        searchterms: ["sponsors", "sponsor category", "sponsor logo", "add sponsor", "edit sponsor", "sponsor category", "sponsor", "logo size", "add sponsor", "create sponsor"]
      },

      areamap: {
        title: "Map",
        searchterms: ["area maps", "foyer", "map", "maps", "foyer maps", "venue maps", "direction", "add area map", "create area map", "create venue map", "add venue map", "add venue orientation", "create venue orientation", "create map", "add map", "create foyer map", "add foyer map"]
      },

      exhibitors: {
        title: "Expo",
        searchterms: ["expo", "stand", "booth", "stands", "booths", "add stand", "edit stand", "add booth", "edit booth", "virtual stand", "virtual booth"]
      },

      documents: {
        title: "Files & Documents",
        searchterms: ["files", "documents", "files and documents", "add presentation", "add brochure", "add file", "presentation files", "file category"]
      },

      faq: {
        title: "FAQ",
        searchterms: ["f.a.q", "frequently asked questions", "faq", "faq", "attendee information", "event information", "information content", "add f.a.q", "create faq", "add faq", "create faq", "add f.a.q", "create f.a.q", "create frequently asked questions", "add frequently asked questions"]
      },

      moderation: {
        title: "Moderation",
        searchterms: []
      },

      reviews: {
        title: "Session reviews",
        searchterms: ["session ratings", "ratings", "content rating", "session comments", "session ratings", "session star", "content point", "content comments", "content ratings", "program rating", "program comments", "program stars", "program ratings"]
      },

      socialhub: {
        title: "Social hub",
        searchterms: ["sosyal media", "sosyal hub", "post", "post hub", "comment", "social moderation", "post moderation", "announcements", "make an announcement", "share announcement", "announcement", "social share", "share post", "post comments"]
      },

      surveys: {
        title: "Surveys",
        searchterms: ["survey", "surveys", "event surveys", "survey report", "create survey", "add survey", "share survey", "publish survey"]
      },

      polls: {
        title: "Live votings",
        searchterms: ["live voting", "voting", "polls", "keypad", "voting report", "publish voting", "share voting", "add voting", "create voting"]
      },

      questions: {
        title: "Ask the speakers",
        searchterms: ["ask the speaker", "question system", "online q&a", "ask live question", "ask the speaker a question", "question subject", "start online Q&A", "Live Q&A", "live questions"]
      },

      networkingrooms: {
        title: "Networking rooms",
        searchterms: ["networking areas", "virtual networking", "networking rooms", "online networking", "live networking", "video call", "live meeting ", "networking tables", "add networking area", "create networking", "add networking room", "create networking room", "add live meeting room", "create live meeting room", "add live meeting", "create live meeting", "add networking", "create networking", "networking"]
      },

      album: {
        title: "Album"
      },

      livesessions: {
        title: "Live sessions",
        searchterms: ["live broadcasting system", "live event", "virtual event", "online event", "live session", "virtual session", "live event experience", "add live session", "add virtual session", "add live program", "add live broadcast", "live broadcast record", "create live broadcast"],
        rtmpCopy: "Copy"
      },

      modules: {
        title: "Modules",
        searchterms: []
      },

      toolshelpers: {
        title: "Supporting Tools",
        searchterms: []
      },
      recordSales: {
        participants: "Attendee list",
        searchterms: []
      },
      rsvps: {
        title: "RSVPs & Invitations",
        searchterms: [
          "invitation",
          "einvitation",
          "e-invitation",
          "rsvp",
          "e-rsvp",
          "ersvp",
          "recipient group",
          "recipient list",
          "send invitation",
          "invitation tasks",
          "create invitation",
          "add invitation",
          "add invitation",
          "create invitation draft",
          "add invitation draft",
          "edit invitation draft",
          "invitation recipient group",
          "invitation recipient group",
          "import invitee list",
          "invitation status",
          "invitation report",
          "send einvitation",
          "einvitation drafts",
          "create einvitation",
          "add einvitation",
          "edit einvitation",
          "create einvitation draft",
          "add einvitation draft",
          "edit einvitation draft",
          "einvitation recipient group",
          "einvitation recipient list",
          "import einvitation list",
          "einvitation status",
          "einvitation report",
          "send e-invitation",
          "e-invitation drafts",
          "create e-invitation",
          "add e-invitation",
          "edit e-invitation",
          "create e-invitation draft",
          "add e-invitation draft",
          "edit e-invitation draft ",
          "e-invitation recipient group",
          "e-invitation recipient list",
          "import e-invitation list",
          "e-invitation status",
          "e-invitation report",
          "RSVP calls",
          "rsvp",
          "rsvp list",
          "import rsvp list",
          "rsvp status",
          "rsvp report",
          "ersvp calls",
          "ersvp",
          "ersvp list",
          "import ersvp list",
          "ersvp status",
          "ersvp report",
          "e-rsvp calls",
          "e-rsvp",
          "e-rsvp list",
          "import e-rsvp list",
          "e-rsvp status",
          "e-rsvp report"
        ]
      },

      certificastes: {
        title: "Digital certificate",
        searchterms: [
          "certificate",
          "certificates",
          "digital certificate",
          "online certificate",
          "create certicitae",
          "recipient group",
          "certificate recipient group",
          "create recipient group",
          "edit recipient group",
          "add recipient group",
          "create certificate recipient group",
          "edit certificate recipient group",
          "add certificate recipient group",
          "certificate recipients",
          "design certificate",
          "certificate design",
          "add certificate design",
          "create certificate design",
          "add certificate design",
          "certificate designs",
          "send certificate",
          "verify certificate",
          "certificate verification"
        ]
      },

      tableplanner: {
        title: "Tables & seating planner",
        searchterms: ["seating plan", "table plan", "seating planner", "table planner", "table number", "add seating plan", "create seating plan", "edit seating plan", "add table plan", "create table plan", "edit table plan", "create table number", "add table", "create table", "add seating", "create seating", "table type", "add table type", "create table type", "edit table type"]
      },

      tweetwall: {
        title: "Tweetwall",
        searchterms: ["twitwall", "socialwall", "twitter", "tweetwall", "twit wall", "tweet wall", "social wall", "socialwall", "social hub", "twit", "tweet"]
      },

      onsiteutilities: {
        title: "Onsite & Utilities",
        searchterms: []
      },

      promotions: {
        title: "Promotions",
        searchterms: ["promotional products", "product list", "add product", "edit product", "create product", "distribute product", "product stock", "product status", "promotional product systme", "promotional product reports"]
      },

      controlpoints: {
        title: "Control points",
        searchterms: [
          "Control points",
          "access control",
          "participation control",
          "entrance and exit control",
          "entrance report",
          "entrance list",
          "entry restriction",
          "attendance restriction",
          "session restriction",
          "access restriction",
          "access report",
          "access list",
          "access control",
          "everyone is allowed",
          "tag restriction",
          "tag access restriction",
          "attendee access restriction",
          "attendance access restriction",
          "sub-event access restriction",
          "sub-event access control",
          "live event access control",
          "online event access control",
          "live broadcast access control",
          "subevent access restriction",
          "live event access restriction",
          "online event access restriction",
          "subevent access status",
          "live event checkin status",
          "online event checkin status",
          "live broadcast checkin status",
          "subevent checkin status",
          "live event access status",
          "online event access status",
          "live broadcats access status",
          "sub event checkin report",
          "live event checkin report",
          "online event checkin report",
          "live broadcats checkin report",
          "sub-event access report",
          "live event access report",
          "online event access report",
          "live broadcats access report",
          "live event access records",
          "online event checkin reports",
          "live broadcats checkin report",
          "live event checkin records",
          "sub event checkin records",
          "live event access record",
          "online event access record",
          "live broadcast access record"
        ]
      },

      controlequipments: {
        title: "Control equipments",
        searchterms: ["turnstile", "turnstile access control", "turnstile checkin control", "checkin records", "entrance records", "access records", "turnstile checkin records", "turnstile entry records", "mobile control", "mobile access control", "mobile checkin control", "mobile checkin reports", "mobile access reports", "controller", "checkin controller", "access controller", "mobile control charge status", "controller list", "checkin control list", "access control list"]
      },

      badgedesigner: {
        title: "Badge designer",
        searchterms: [
          "badge print",
          "badge design",
          "create badge design",
          "create badge design template",
          "create badge print draft",
          "add badge design",
          "add badge print template",
          "add badge print draft",
          "edit badge design",
          "edit badge print template",
          "edit badge print draft",
          "badge",
          "badge print",
          "badge print design",
          "create badge design",
          "create badge print template",
          "create badge print draft",
          "add badge print design",
          "add badge print template",
          "add badge print draft",
          "edit badge print design",
          "edit badge print template",
          "edit badge design"
        ]
      },

      messages: {
        title: "Automated messages",
        searchterms: []
      },

      eventusers: {
        title: "Users",
        searchterms: ["users", "admins", "authorization group", "authorization groups", "authorizations", "authorization", "invite", "user invitation", "admin invitation", "team member", "invite team member", "authorize team member", "authorize user", "add user", "add admin", "delete user", "block user", "delete admin", "block admin"]
      }
    },

    components: {
      eventInfo: {
        about: {
          title: "Event information",
          eventName: "Event title",
          eventColor: "Color",
          date: "Start & End date",
          logo: {
            title: "Event logo",
            description: "500 x 500 pixel",
            cancel: "Remove"
          },
          cover: {
            title: "Event cover",
            description: "1120 x 500 pixel",
            cancel: "Remove"
          },
          aboutEvent: {
            title: "About event"
          }
        },
        location: {
          title: "Location",
          country: "Country",
          city: "City",
          address: "Full address",
          venueName: "Venue"
        },
        social: {
          title: "Social links",
          page: "Website"
        },
        contact: {
          title: "Contact",
          firmName: "Organizer",
          contactNum: "Phone number",
          contactMail: "Email",
          address: "Full address"
        },
        settings: {
          title: "General settings",

          currency: {
            title: "Currency",
            description: "The selected currency will be valid for all monetary transactions in the event."
          },
          autoCheckin: {
            title: "Automatic Check-in",
            description: "Attendees who have a badge, QR code or Voucher can directly pass through the access control points. When this option is activated, the system automatically performs check-ins when the attendees scan their code."
          },
          users: {
            part1: "Check-in attendees again ",
            part2: "at the first check-in after 1140 minutes."
          },
          networking: {
            title: "Networking features",
            description: "When the networking features are inactive, attendees cannot reach other attendees through the mobile application and cannot share any content in social areas.",
            active: "Active",
            inactive: "Inactive"
          },
          displayRegister: {
            title: "Online registration",
            description: "Activate your online registration screen to publish your registration forms and get registration."
          }
        },
        register: {
          title: "Online registration screen",
          ticketDisplay: "Title",
          upperBanner: "Top banner (1000x100 px)",
          lowerBanner: "Bottom banner (1000x100 px)",
          ticketDisplayDesc: "Registration description",
          thirdPartyHead: "Third party code (Head Tag)",
          thirdPartyBody: "Third party code (Body Tag)"
        },
        payment: {
          title: "Payment settings",
          creditCard: {
            title: "Payment by credit card",
            register: "Online paid registration:",
            selectPos: "Select POS",
            posDesc: "You must activate this to receive payments via online credit and debit cards. To receive payment, you must apply to your bank for Virtual POS and get approval for your application. ",
            description: {
              title: "All virtual POS available in Holacon is listed below. You can contact us at support@holacon.com to activate any POS and use it in your online sales.%{href}.",
              description: {
                title: "For POS Application",
                condition1: "If your bank or payment institution makes any IP restrictions, please contact them.",
                condition2: "Sales on Holacon are made in 3Ds. Confirm that 3Ds usage is active on your POS.",
                condition3: "You have to inform us about (Terminal ID (ClientId), API User Name, API Password, StoreKey) information during your application process."
              }
            }
          },
          transfer: {
            title: "Payment by wire transfer",
            register: "Paid registration by wire transfer",
            description: "You can receive payment by bank transfer for your event sales by activating this. The system generates a remittance code during the transaction, and the attendee is asked to write this code in the payment description.",
            info: {
              title: 'The bank information you will add below is shown to the attendees who select the "Pay by Wire Transfer" option and are requested to make a payment to any of them.',
              bankName: "Bank name",
              iban: "IBAN",
              accountNo: "Account no",
              recipient: "Account holder",
              branchNo: "Branch code",
              swift: "Swift code"
            }
          }
        },
        subEvents: {
          title: "Sub Events",
          navbar: {
            filterRecord: "Search sub-events..."
          }
        },
        voucher: {
          title: "Voucher templates",
          modalTitle: "Add/Edit voucher template"
        },
        modules: {
          title: "Application modules",
          tableTitle: "Add/Edit module",
          webview: "Webview modules"
        }
      },
      query: {
        normal: "Regular Register",
        press: "Press",
        standard: "Standard Attendance",
        oneday: "Single Day Attendance",
        sebeventPackege: "Single Sponsored Sub-Event Package",
        student: "Student",
        titleOthers: "Other Registration Informations",
        email: "E-Mail",
        phone: "Regular Phone 2",
        dayRest: "Day Restriction"
      },
      participants: {
        title: "Attendees",
        navbar: {
          transfer: {
            title: "Data Transfer",
            export: "Export",
            import: "Import",
            createTask: "Create a draft",
            exTask: "List Template",
            transferDraft: "transfer draft",
            searchFilter: "Search / Filter"
          },
          certificate: {
            title: "Certificate",
            all: "Send to all"
          },
          filterRecord: "Filter",
          add: "Add",
          tags: "Tags",
          category: "Categories"
        }
      },
      registerEvent: {
        groups: "Attendee Groups",
        registerSubevent: "Sub-event registration",
        sales: "Sales Packages",
        coupon: "Discount Coupons",
        paymentApp: "Payments & Confirmation"
      },
      sponsors: {
        main: "Main Sponsors",
        co: "Co-Sponsors",
        services: "Service Sponsors",
        supports: "Support Sponsors",
        example: "Example Category",
        add: "Add Category"
      },
      moderation: {
        title: "Session Reviews",
        social: {
          pic: "Click to upload an image"
        },
        vote: {
          title: "Add / Edit",
          which: "Related live session",
          votePassive: "Passive",
          voteActive: "Active",
          screenPassive: "Passive",
          screenActive: "Active"
        },
        askToSpeaker: {
          title: "Topics",
          questionNumber: "Total questions",
          newQuestions: "New questions",
          seeQuestions: "See questions",
          openScreen: "Display",
          yesGet: "Yes",
          noDont: "No"
        }
      },
      liveEventExp: {
        title: "Live Broadcast",
        nav: {
          scenes: {
            title: "Stages",
            designs: "Stage designs",
            addScene: "Add/Edit stage",
            topBanner: "Upload top banner",
            topBannerDesc: "1000x100 px (max 1000px, min 100px)",
            background: "Upload background",
            backgroundDesc: "1920x1200 px",
            bottomBanner: "Upload bottom banner",
            bottomBannerDesc: "1000x100 px (max 1000px, min 100px) for logo etc."
          }
        }
      },
      rsvps: {
        menu: {
          tags: "Tags"
        }
      }
    },

    filter: {
      title: "Filter",

      search: "Search",
      group: "Attendee group",
      tag: "Tag",
      day: "Day",
      stage: "Stage",
      allStages: "All stages",
      registrationForm: "Registration form",
      registrationPackets: "Packets",
      paymentInfo: "Payment and registration info",
      paymentID: "Payment ID",
      couponCode: "Coupon code",
      paymentStatus: "Payment status",
      paymentType: "Payment type",
      dayRestriction: "Day Restriction",
      subEvents: "Sub events",
      filterMsg: "Narrow your search with the filter options.",
      voucherInfo: "Automated message info",
      shippingStatus: "Sending status",
      voucherType: "Voucher type",
      automatedMessageId: "Automated Message",
      automatedMessageStatus: "Automated Message Status",
      automatedMessageType: "Automated Message Type",
      messageStatus: "Message status",

      promotions: "Promotions",
      participantNo: "Attendee NO",

      activationInfo: "Activation info",
      activationStatus: "Status",
      activationCode: "Activation code",

      checkinInfo: "Check-in information",
      checkinStatus: "Check-in status",

      all: "All",
      checkedIn: "Cheked-in",
      unchecked: "Not checked-in",
      dates: "Date",

      cardPrintInfo: "Printing info",
      createDateInfo: "Date",
      cardPrintStatus: "Printing status",
      cardPrinted: "Printed",
      cardNonPrinted: "Not printed",
      minDate: "Starting date",
      maxDate: "End date",
      minCheckin: "Starting date",
      maxCheckin: "End date"
    },

    variables: {
      tr: "Turkish",
      en: "English",
      yes: "Yes",
      no: "No",
      new: "new",
      media: "media",
      singular: "singular",
      minutes: "minutes",
      like: "like",
      comment: "Comment",
      waitApprovement: "Confirmation required",
      autoApprovement: "Auto confirm",
      name: "Name",
      surname: "Surname",
      email: "E-Mail",
      phone: "Phone",
      firmSchool: "Company/School ",
      titleSection: "Title/Department",
      moreInfo: "Additional info",
      invitationCode: "Invitation Code"
    },
    tags: {
      pending: "Pending",
      speakers: "Speakers",
      program: "Program",
      sponsors: "Sponsors",
      participants: "Attendees",
      social: "Social",
      album: "Photo album",
      surveys: "Surveys",
      voting: "Live voting",
      askToSpeaker: "Ask speaker",
      areaMaps: "Area maps",
      areaMap: "Area map",
      library: "FAQ",
      documents: "Documents",
      stand: "Stands",
      all: "All",
      approved: "Confirmed",
      canceled: "Canceled",
      sponsorLogo: "Sponsor logo (min. 500x500 px)",
      stantCoverImg: "Cover image",
      stantImg: "Stant Image",
      editSponsor: "Add/Edit sponsor",
      active: "Active",
      passive: "Passive",
      sizeLogo: "Logo size",
      stants: "Stands",
      saloons: "Halls",
      links: "Links",
      description: "Description",
      docs: "Files & Documents",
      editDocs: "Add/Edit files & documents",
      editQuest: "Add/Edit question",
      socialHub: "Social hub",
      editSurvey: "Add/Edit survey",
      responsesSurvey: "Survey responses",
      questions: "Questions",
      secretSurvey: "Private survey",
      statisticsSurvey: "Survey statistics",
      addQuestion: "Add question",
      editLive: "Add/Edit live voting",
      editSession: "Add / Edit live session",
      whichSession: "Related live session",
      allSessions: "All Sessions",
      session: "Session",
      moderationAct: "Activate moderation?",
      getQuest: "Get new questions",
      editLabel: "Add / edit tag",
      addGroup: "Add group",
      editGroup: "Edit Group",
      addVimeo: "Add/edit Vimeo live session",
      startEndDate: "Start - end date (Select a date range)",
      cloudArchiving: "Cloud Archiving",
      deactive_: "Passive",
      active_: "Active",
      archiveVimeo: "Archiving should be done via Vimeo.",
      addParticipant: "Add attendee",
      editParticipant: "Edit attendee",
      editPrintDesign: "Add/Edit badge design",
      accessType: "Access type",
      backgroundImg: "Background image",
      backgroundImgDesc: "1920x1200px",
      certDesign: "Certificate designs",
      participationCert: "Participation certificate",
      certTitle: "Title",
      editGuest: "Add/edit attendee",
      editTask: "Add/Edit template",
      guestLabel: "Attendee tag",
      guestLabels: "Attendee tags",
      colorCode: "Color code",
      currentPack: "Current packages",
      invite: "Send an invitation",
      task: "Template",
      lcvTask: "RSVP & invitation drafts",
      editGuestLabel: "Add/edit invitation tag",
      editParticipant_: "Add/edit invitee",
      editPromo: "Add/edit promotion",
      editCheckpoint: "Add/edit venue",
      addCheckpoint: "Add venue",
      entryRecord: "Access control registrations",
      height: "Height (mm)",
      width: "Width (mm)",
      mt: "Margin top (mm)",
      mb: "Margin bottom (mm)",
      ml: "Margin left (mm)",
      mr: "Margin right (mm)",
      mail: "User e-mail:",
      authNo: "Number of authorized",
      editPack: "Add/edit package category",
      editStand: "Add/edit stand",
      standHalls: "Stand halls",
      halls: "Halls",
      editCustom: "Add/edit custom fields",
      editSubEvent: "Add/edit sub-event",
      addSubEvent: "Add sub-event",
      addNewProduct: "Add/edit product",
      stockQuantity: "Quantity",
      editVoucher: "Add/edit voucher template",
      addProxy: "Add proxy"
    },

    buttons: {
      update: "Update",
      save: "Save",
      logout: "Logout",
      clear: "Clear",
      published: "Published",
      notPublished: "Not Published",
      deleteAccount: "Delete account",
      addAccount: "Add bank account",
      active: "Active",
      inactive: "Passive",
      go: "Go",
      remove: "Remove",
      close: "Close",
      displayOptions: "Display options",
      all: "All",
      selectAll: "Select all",
      unselectAll: "Unselect all",
      closeDetailed: "Close",
      addDay: "Add Day",
      editDay: "Add/edit day",
      editProgram: "Add/edit program",
      editStage: "Add/edit stage",
      embed: "Embed on a website",
      showSpeakers: "Show speakers",
      hideSpeakers: "Hide speakers",
      announcement: "Share announcement",
      goLiveVote: "Live voting screen",
      addAnswer: "Add answer",
      edit: "Edit",
      downloadReport: "Download report",
      showAnswers: "See answers",
      showNotifications: "Show reminder notification",
      copy: "Copy",
      addNew: "Add new",
      refresh: "Refresh",
      helpdesk: "Helpdesk",
      details: "Details",
      reset: "Reset",
      openDetailed: "Detailed search",
      closeDetailed: "Close search",
      cancel: "Cancel",
      hide: "Hide",
      show: "Show",
      addStage: "Add new stage",
      editCat: "Edit category",
      addSponsor: "Add sponsor",
      addCategory: "Add/edit category",
      addSpeaker: "Add/edit speaker",
      delete: "Delete",
      checkinList: "Check-in list",
      addLink: "Add new link",
      goLiveVoting: "Live voting screen",
      select_: "Select",
      selected: "Selected",
      changeBackground: "Change background",
      designCert: "Design new certificate",
      addText: "Add text",
      addImg: "Add image",
      var: "Variables",
      back: "Back",
      tasks: "Templates",
      authGroup: "Authority group",
      authGroups: "Authority groups",
      authorize: "Authorize",
      filter: "Filter",
      view: "Show",
      seeAbstractDetails: "See abstract details",
      undoChanges: "Undo changes",
      sendAgain: "Send again",
      registerLink: "Registration Link"
    },

    textbox: {
      search: "Search...",
      search_: "Search...",
      searchPID: "Search by attendee...",
      searchCC: "Search by coupon code...",
      maxCheckinDate: "Maximum check-in date",
      minCheckinDate: "Minimum check-in date",
      select: "Select...",
      selectTag: "Select tag",
      selectStatus: "Select status",
      filterPack: "Filter by package",
      selectPack: "Select package",
      selectSub: "Select sub-event",
      filterAreaType: "Filter by field type",
      filterGrp: "Search by group...",
      filterLabel: "Search...",
      payType: "Select a payment type",
      payStat: "Select a payment status",
      toDelete: "Are you sure to delete?",
      expLib: "EG: What is the Wi-Fi password?",
      speakerFilter: "Search by speaker name, company and title...",
      libSearch: "Search by question title or content...",
      programrateSearch: "Search by ratings...",
      expVIP: "EG: VIP attendees",
      searchForParticipant: "Search attendees...",
      datePickerStart: "Start date & time",
      datePickerEnd: "End date & time",
      datePickerStart_: "Start date",
      datePickerEnd_: "End date",
      selectTask: "Select Draft",
      selectPromo: "Select a product",
      searchPromo: "Search by product name...",
      selectAuth: "Select authority group",
      use: "It will be used in access operations...",
      selectLang: "Language selection",
      proxy: "Indicate your reason for adding a proxy.",
      selectVoucher: "Select Voucher Type",
      selectVtemp: "Select Voucher Template",
      certNote: "You have been awarded this certificate for your interest and participation in our event. We wish you continued success.",
      certAppeal: "Dear %participant.name% %participant.surname% ",
      selectPromotion: "Select promotion"
    },

    table: {
      title: "Title",
      title_: "Title",
      firstname: "Firstname",
      lastname: "Lastname",
      fullname: "Fullname",
      participantNO: "Attendee no",
      certNO: "Certificate number",
      checkpoint: "Venue",
      stock: "Stock",
      confirmationRequired: "Confirmation required",
      recordActive: "Record active",
      language: "Language",
      processes: "Processes",
      link: "Link",
      justParticipants: "Only attendees",
      participantID: "Attendee ID",
      activationCode: "Activation code",
      required: "Required",
      onAir: "Published",
      type: "Type",
      packages: "Assigned packages",
      color: "Color",
      publishApp: "Publish in the app?",
      cardPrint: "Print badge",
      registerDate: "Registration date",
      subEvent: "Sub-event",
      company: "Company",
      queue: "Order",
      day: "Day",
      comment: "Comment",
      qr: "QR Code",
      statistics: "Statistics",
      responses: "Responses",
      edit: "Edit",
      try: "Try it",
      delete: "Delete",
      sequence: "Order no",
      privacy: "Privacy",
      group: "Group",
      label: "Tag",
      price: "Price",
      download: "Download",
      F: "VAT",
      salesStock: "Sales / stock",
      package: "Package",
      prefix: "Prefix",
      suffix: "Suffix",
      code: "Code",
      remaining: "Remaining",
      showCodes: "Show codes",
      payAmount: "Payment amount",
      details: "Details",
      abort: "Cancel payment",
      approve: "Approve",
      cancelRec: "Cancel registration",
      speaker: "Speaker",
      passive: "Passive",
      active: "Active",
      content: "Content",
      gallery: "Gallery",
      participant: "Attendee",
      confirmAss: "Confirm",
      rejectAss: "Reject",
      participating: "Participation",
      comments: "Comments",
      startEnd: "Start/end",
      totalTime: "Total time",
      totalStock: "Total stock",
      status: "Status",
      broadcastRecords: "Broadcast records",
      totalPerson: "Number of attendees",
      personInfo: "Attendee Info",
      invitationCode: "Invitation code",
      send: "Send",
      firmSchool: "Company / School",
      titleDepartment: "Title / Department",
      additionalInfo: "Additional information",
      transfer: "Transfer",
      chargeStatus: "Charge status",
      distributed: "Distributed",
      distPromotions: "Distributed products",
      promotion: "Promotional product",
      piece: "Quantity",
      date: "Date",
      entryRecords: "Entrance history",
      seatingPllaner: "Seating arrangement",
      pass: "Pass permit",
      controller: "Controller",
      controlType: "Control type",
      place: "Place",
      heightWidth: "Width / Height",
      margin: "Margin (left, top, right, bottom)",
      customText: "Text customization",
      userNo: "Number of users",
      editAuth: "Add / edit authority group",
      user: "User",
      fastlogin: "Fast login",
      messagetype: "Message type",
      clickforfastlogin: "Click for fast login"
    }
  },

  redirects: {
    redirect1: {
      title: "Define event days",
      description: "You must specify the event days to create an event program, manage registration and sales packages, and publish your event."
    },
    redirect2: {
      title: "Create attendee groups",
      description: "Attendee groups show attendees classified in more than one category under one group. e.g., Student, press, exhibitor etc. Each tag must have a related group."
    },
    redirect3: {
      title: "Create attendee tags",
      description: "Tags allow the segmentation of attendees. It is necessary to create a tag for all functions such as entrance control, ticket sales, registration, sub-event registration, seating planning and reporting."
    },
    redirect4: {
      title: "Create registration / sales packages",
      description: "In order to get registration and sell tickets, you must create at least one participation package, including free events."
    },
    redirect5: {
      title: "Create online registration form",
      description: "It allows you to define inputs and options you would like to get from your attendees.  Thanks to the customisations, you can get unique registrations and add particular fields to registration packages."
    },
    redirect6: {
      title: "Define control points",
      description: " Control points are defined areas for controlling and reporting the entrances and exits of attendees throughout the event. Sub-events, programs, live broadcasts, networking areas and onsite entrance controls are carried out through these control points."
    },
    redirect7: {
      title: "Create and manage your content",
      description: "Create, manage, edit and publish all the details of your event."
    },
    redirect8: {
      title: "Create your live session",
      description: "Live sessions are virtual sessions broadcast on the Live Event Experience platform. Attendees can attend these sessions online within their registration rights."
    }
  },

  information: {
    module: "This module is not ready for use yet.",
    moduleDesc: "This module is currently under testing. Soon to be available.",
    sureToBack: "Are you sure you want to go back?",
    export: "Are you sure you want to export the record?",
    warn: "Attention"
  },

  exp: {
    participant: "eg: Doe",
    participant_: "eg: Jane"
  },

  reports: {
    totalParticipants: "Total attendees",
    blockedParticipants: "Blocked attendees",
    surrogateParticipant: "Substitute attendees",
    totalSale: "Total sales",
    totalCheckin: "Total check-in",
    totalCardPrinted: "Total printed badges",
    sentVoucherMail: "Voucher sent (e-mail)",
    sentVoucherSms: "Voucher sent (SMS)",
    totalCouponGroup: "Total coupon code group",
    totalCouponPiece: "Total number of coupon codes",
    couponUsed: "Used coupon code",
    couponUnused: "Unused coupon code",

    activationAnalysis: "Activation Analysis",
    waitingAct: "Pending activation",
    canceledAct: "Activation canceled",
    activated: "Activated",

    totalParticipantsPack: "Number of attendees by packages",

    attendanceChartByTags: "Attendance chart by tags",

    accessControlByLoc: "Access control by venue",
    venue: "Venue",
    totalEntry: "Total check-in",
    singleEntry: "Single check-in",

    accessControlByLive: "Access control by live sessions",
    session: "Session"
  },

  enums: {
    currency: {
      other: "Other"
    },

    status: {
      waitApprove: "Waiting confirmation",
      approved: "Approved",
      rejected: "Rejected",
      canceled: "Canceled",
      autoApprove: "Auto-confirm",
      waitForApprove: "Wait for confirmation",
      sent: "Sent",
      delivered: "Delivered",
      clicked: "Link Clicked",
      spam: "Spam",
      registered: "Registered",
      opened: "Opened",
      failed: "Failed to send"
    },

    discountType: {
      discountPercentage: "Discount percentage",
      certainAmount: "A certain amount of discount"
    },

    accessTypes: {
      all: "All Tags",
      certain: "Specific tags",
      onlyRegistrants: "Registrants only"
    },

    voucherSendStatus: {
      transmitted: "Sent",
      read: "Read",
      failed: "Failed to send",
      complaint: "Received a complaint",
      noMail: "E-Mail does not exist",
      noPhone: "Missing phone number",
      error: "Error",
      unknownError: "Unknown error"
    },

    voucherTaskStatus: {
      duringShipping: "Pending",
      complete: "Completed",
      error: "Error occurred",
      notesreferences: "voucher not sent",
      mail: "Sending Email",
      sms: "Sending SMS"
    },

    paymentType: {
      free: "Free participation",
      online: "Online paid participation",
      transfer: "Paid participation by wire transfer"
    },

    activationStatus: {
      wait: "Waiting for activation",
      activated: "Activated",
      canceled: "Activation cancelled"
    },

    inputTypes: {
      uniqueMail: "Unique e-mail",
      uniquePhone: "Unique mobile phone",
      company: "Company name",
      title: "Title",
      school: "School",
      department: "Department",
      sex: "Sex",
      country: "Country",
      city: "City",
      IdPassNO: "ID / Passport Number",
      studentNo: "Student number",
      lang: "Language",
      birth: "Date of birth",
      profession: "Profession",
      expert: "Expertise",
      text: "Text",
      multilineText: "Multiline text",
      mail: "E-mail",
      phone: "Phone number",

      figure: "Number",
      singlesreferences: "Single selection",
      multiChoice: "Multiple selection",
      invitationCode: "Invitation code"
    },

    invoiceType: {
      corpBilling: "Corporate invoice",
      individualBilling: "Individual invoice"
    },

    galleryType: {
      photo: "Photography"
    },

    usageType: {
      eventCreated: "Event created",
      participantAdded: "New attendee added",
      participantsAdded: "Bulk attendee added",
      participantRegistered: "Attendee registered.",
      eventAired: "Event published.",
      smsActivation: "SMS activation",
      voucherSent: "Voucher sent",
      invitationSent: "Invitation sent",
      cardPrinted: "Printed",
      checkinDone: "Checked-in",
      inputControl: "Access control",
      promo: "Promotional product",
      report: "Report",
      voucherSms: " SMS voucher sent",
      liveSessionsCreated: "Live session created",
      twoPerson: "A networking room for 2 people was created.",
      fourPerson: "A networking room for 4 people was created.",
      sixPerson: "A networking room for 6 people was created.",
      liveParticipation: "Live session attendance",
      enterNetworking: "Networking room entrance",
      liveSessionArchive: "Download live session archive",
      manuel: "Manual identification",
      invitationAdded: "Added invitee to the e-invitation list.",
      invitationSent: "E-invitation sent",
      couponUsed: "Coupon code used",
      giftUsed: "Gift code used",
      loanPurchased: "Credit purchased",
      certSent: "Certificate sent"
    },

    printMode: {
      dontCustom: "Do not customize",
      allCaps: "ALL UPPERCASE",
      allLower: "all lowercase",
      firstCaps: "First Letters In Uppercase"
    },

    questionType: {
      textInput: "Text input",
      single: "Single selection",
      multiple: "Multi selection"
    },

    accessLogType: {
      mobilLive: "Mobile / Live",
      tourniquet: "Turnstile"
    },

    accessLogStatus: {
      granted: "Allowed",
      disallowed: "Not allowed"
    },

    rsvpStatus: {
      joining: "Attending",
      disagree: "Not attending",
      maybe: "Maybe",
      callAgain: "Call again",
      infoMistaken: "Incorrect information",
      receiveComplaint: "Received a complaint",
      invalidMail: "Invalid e-mail"
    }
  },

  options: {
    seeAll: "See all",
    stand: "Stand",
    date: "Date",
    selectAll: "Select all",
    bio: "Biography",
    female: "Female",
    male: "Male",
    other: "Other",
    confirmation: "{n} credits will be deducted from your account to download this archive. Do you confirm?",
    checkin: "All attendees you have selected will be checked-in. Do you confirm?",
    bulkCheckin: "Bulk check-in",
    participantDetails: "Attendee Details",
    download: "Download",
    delete: "Delete"
  },

  routes: {
    speakers: "Speakers",
    eventSch: "Event schedule",
    sponsors: "Sponsors",
    areaMaps: "Area maps",
    docs: "Documents",
    library: "FAQ"
  },

  message: {
    refreshActivationCode: "Activation code copied.",
    authority: "You do not have the authorization for this.",
    vote: "There cannot be more than one same answer in the voting.",
    fill: "Please fill in all fields.",
    vimeo: "You must add one Vimeo broadcast.",
    waitCheck: "Please wait while attendees check-in ...",
    delete: "You need to enter your account password for bulk deletion.",
    batch: "You are doing bulk processing.",
    waitDeletion: "Please wait while the attendees are deleted ...",
    wrongPass: "Incorrect password",
    export: "Are you sure to export the records?",
    warn: "Attention",
    sureDel: "The records you have selected will be moved. Do you confirm?",
    batchDel: "Bulk delete",
    moveRecords: "The records you selected will be moved. Do you confirm?",
    markOk: "The registrations you selected will be marked as attending. Do you confirm?",
    markAttend: "Mark as attending",
    markNot: "The registrations you selected will be marked as not attending. Do you confirm?",
    sureExport: "Are you sure you want to export the records?",
    sureCreate: "Are you sure you want to create an export file?",
    sureDelCert: "Are you sure you want to delete the certificate?",
    bannedParticipant: "This exhibitor is banned by the organizer.",
    sureRemoveBan: "Do you confirm removing the ban?",
    sureBanned: "This attendee will be banned; do you confirm?",
    ban: "Ban",
    removeBan: "Remove Ban",
    codeRenewed: "Activation code will be renewed, do you confirm?",
    deactivated: "The activation code is not yet activated.",
    sureCheckin: "Do you confirm to check-in?",
    check_in: "Check-in",
    addedProxy: "A proxy has been added to this attendee.",
    viewProxy: "View proxy attendee",
    sendV: "Send voucher",
    sureCancel: "Are you sure to cancel the payment? This transaction cannot be revoked.",
    subeventRecords: "Sub-event registrations",
    otoSave: "Auto registration",
    onlinePays: "Online payments",
    records: "Records",
    onsiteProcess: "Onsite operations",
    cardPrint: "Badge printing",
    sureToDel: "Are you sure to delete ? This transaction cannot be revoked.",
    promotion: "Promotional products",
    transDate: "Transaction date",
    voucher: "Voucher",
    deliveryStat: "Delivery status",
    certs: "Certificates",
    shippingDate: "Delivery date",
    download: "Downloads",
    visited: "Visits",
    cert: "Certificate",
    payDetails: "Payment details",
    creditPack: "Credit packages",
    proxyReason: "Reason for adding a proxy",
    printCard: "Print badge",
    cardTask: "Badge template",
    selectCardTask: "Choose badge template",
    paymentFailed: "Payment failed",
    paymentSuccess: "Payment successfully completed",
    alert: "{n} cards were printed to this attendee before. Please specify a reason for reprinting.",
    printAndCheckin: "Print and check-in",
    print: "Print",
    voucherSend: "Vouchers will be sent to {count} person.",
    voucherTemp: "Voucher template",
    printerID: "Printer ID",
    noStageDesign: "There is no stage design yet.",
    manageScenes: "Manage stages",
    copiedLink: "Link copied",
    copiedCode: "Code copied",
    copied: "Copied",
    scenes: "Stages"
  },

  search: {
    proxy: "Since a proxy is assigned to this attendee, you cannot print a badge and check in.",
    blocked: "You cannot print badges and check-in because this attendee is blocked.",
    payment: "Payment registration for this attendee has not been confirmed yet. Please confirm the registration or contact the organizer.",
    cancel: "This attendee's payment has been cancelled. Please get in touch with the organizer.",
    notToday: "As this attendee's registration is on a different day, you cannot print a badge and check-in."
  },

  detail: "Transaction details",
  addNew: "-- Add New --",
  discountType: "Discount type",
  discountPerc: "Discount percentage",
  discountAmount: "Discount amount",
  downloads: "Total downloads",
  authDesc: "When you assign a team member for the management of coupons, a reminder e-mail is sent to this person for sending and using the coupons.",
  defineAuth: "Assign an user",
  authSurname: "User surname",
  authName: "User name",
  authMail: "User E-Mail",
  myAccount: "My account",
  notifications: "Notifications",
  companyInfo: "Company information",
  summary: "Usage summary",
  loadCredit: "Buy credits",
  history: "Transaction summary",
  soon: "soon",
  signOut: "Sign out",
  badge: "Badge",
  startDate: "Start date",
  endDate: "End date",
  enterText: "Insert text here...",
  enterPhone: "Enter your phone number",
  resetFilter: "Reset filter",
  createNew: "Create new registration",
  active: "Active",
  inactive: "Passive",
  justThesePacks: "Define only for the following packages",
  require: "Compulsory?",
  includeSearch: "Include in tables and searches",
  type: "Type",
  editGroup: "Add/edit group",
  editPack: "Add/edit package",
  category: "Category",
  tag: "Tag",
  price: "Price",
  taxRate: "Tax rate",
  packDesc: "Package description",
  oneDay: "Single day restriction",
  autoSubEvent: "Automatic sub-event registration",
  secret: "Private package",
  secretDesc: "Packages that you define as private are not listed on the registration screen. You can only share links for these packages—e.g., registration links that you will create specifically for your sponsors.",
  acreditaionMode: "Accreditation mode",
  acreditationDesc: "When the accreditation mode is active, free registrations will be approved first. In case of inactive registrations are automatically approved. Accreditation mode is activated automatically in paid packages.",
  invitationCode: "Invitaion code required",
  invitationDesc: "Packages that you define as 'invitation code required' only get registrations with a special invitation code. You can send the codes via the online invitation & RSVP system to the attendees who would like to invite.",
  editCoupon: "Add/edit coupon",
  prefix: "Prefix",
  suffix: "Suffix",
  numberCpn: "Number of coupons",
  usageLimit: "Usage limit for each coupon",
  pack: "Package",
  exHlcn: "Ex: HLCN",
  ex2020: "Ex: 2020",
  customerInfo: "Customer information",
  phone: "Phone number",
  mail: "E-mail",
  bill: "Billing information",
  summary: "Summary",
  paymentType: "Payment type",
  transferCode: "Wire transfer code",
  decimatedTotal: "Subtotal",
  discounts: "Discounts",
  taxes: "Taxes",
  total: "Total",
  general: "General information",
  daySelection: "Day selection",
  noRestriction: "No day restriction",
  addSubEvent: "Add sub-event registration",
  subEvent: "Sub-event",
  selectedParticipants: "Selected attendees",
  participantList: "Attendee list",
  searchPart: "Search in attendees...",
  selectTag: "Select tag",
  select: "Select",
  exOzk: "Ex: Özkan Taştan",
  ex1: "Ex: 1",
  exSup: "Ex: support@holacon.com",
  exGir: "Ex: Entrepreneur",
  exFcb: "Ex: https://www.facebook.com/holacon",
  exTwt: "Ex: https://www.twitter.com/holacon",
  exLnk: "Ex: https://www.linkedin.com/holacon",
  exIns: "Ex: https://www.instagram.com/holacon",
  exPint: "Ex: https://www.pinterest.com/holacon",
  exGoogle: "Ex: https://plus.google.com/holacon",
  exDribble: "Ex: https://www.dribble.com/holacon",
  exIs: "Ex: İş Bankası",
  exIban: "Ex: TR89 3704 0044 0532 0130 00",
  exFull: "Ex: Jane Doe",
  exRndm: "Ex: 123456",
  exRndm2: "Ex: 753",
  exHolacon: "Ex: Holacon",
  exHol: "Ex: https://www.holacon.com",
  accountInfo: "For your account security, we recommend renewing your password every six months.",
  neverUpdated: "You haven't updated your password yet.",
  sendNotification: "Notification will be sent to all attendees, do you confirm?",
  reminder: "Send notification",
  progType: "Program type",
  startTime: "Start time",
  endTime: "End time",
  addSpeaker: "Add speaker",
  accountInformation: "Account",
  appSettings: "Settings",
  phone1: "Phone number",
  passSettings: "Password",
  password: "Current password",
  newPass: "New password",
  newPass_: "Retype new password",
  name: "Name",
  surname: "Surname",
  searchWithinP: "Search in speakers...",
  drag: "Drag and drop to order",
  addDay: "Add day",
  addSaloon: "Add hall",
  selectedSpeakers: "Selected speakers",
  speakerList: "Speaker list",
  searchEventName: "Search by event name...",
  createNewEvent: "Create new event",
  create: "CREATE",
  menu: "Menu",
  addTag: "Add tag",
  important: "Important information",
  usage: "Usage rights are event specific. The rights you do not use in this event cannot be transferred to your next event or requested a refund.",
  remaining: "remaining",
  editAreaMap: "Add/edit area map",
  mainUser: "Main user",
  evaStat: "Rating status",
  sureInvCode: "Are you sure you want to renew the invitation code?",
  note: "Your note",
  submit: "Send",
  addNetArea: "Add/edit networking area",
  activeIt: "Activate",
  packPrice: "PACKAGE PRICE",
  selectedPack: "Selected Package",
  totalUpper: "TOTAL",
  backToPackSel: "Back to package selection",
  popular: "Popular",
  pay: "PAY",
  credit: "Credit",
  buy: "Buy",
  enterEventName: "Enter event name",
  doYouNeedCredit: "Do you need more credits?",
  live: "LIVE",
  waiting: "WAITING",
  editSubject: "Add/edit subject",
  question: "Question",
  like: "Like",
  date: "Registration date",
  stat_: "Status",
  sureToDel_: "Are you sure to delete this post?",
  generalInf: "General information",
  event_: "Event",
  code: "activation code",
  printCard_: "Print badge",
  addVimeo: "Add Vimeo broadcast",
  payInf: "Payment & registration information",
  editMedia: "Add/edit media",
  mediaType: "Media type",
  gallery: "Gallery image",
  social: "Social media accounts",
  three: "3D Image",
  speaker: "Speaker",
  progDetail: "Program detail",
  selected: "Selected",
  cancelSelection: "Cancel selection",
  officialTitle: "Official title",
  firmNo: "Company no",
  billType: "Invoice type",
  taxAd: "Tax Office",
  taxTC: "Tax No & ID No",
  address: "Adress",
  legal: "Corporate",
  person: "Individual",
  couponQ: "Coupon codes will be sent to your e-mail address. Do you confirm?",
  export: "Export",
  regLink: "Registration link",
  codesC: "Coupon codes",
  tooltipSee: "See the attendees used this code.",
  usage_: "Usage",
  invitationArea: "Invitation code field",
  registerButton: "Register now button",
  buttonAddress: "Register button address",
  lcvButtons: "RSVP buttons",
  bottomBannerURL: "Sub banner URL",
  preview: "Preview",
  subImg: "Sub banner",
  removeImg: "Remove image",
  topImgUrl: "Top banner URL",
  emailTitle: "E-mail title",
  topImg: "Top banner",
  selectLang: "Select language",
  batchDel: "Bulk deletion failed",
  move: "Move",
  temp: "Template",
  voucherBoth: "Voucher (SMS & E-Mail)",
  announcementText: "Announcement text",
  secretDesc: "It does not appear in the survey list. Attendees can access the private surveys only by scanning the QR code on the mobile application.",
  exWall: "e.g: Name of the speaker, session title, etc.",
  tableName: "Table Name",
  operant: "Operant",
  viewReg: "View registration screen",
  dayRestrict: "Day restriction",
  lastCheckin: "Last check-in date",
  noRecord: "No registration found",
  sureToDo: "Are you sure to do this process?",
  sureToDelS: "Are you sure to delete this?",
  reInvite: "An invitation will be re-sent. Do you confirm?",
  archiveSess: "Session archive",
  downloadArch: "Click to download archive",
  createReport: "The report will be generated and sent to your e-mail address. Do you confirm?",
  reminderAll: "A reminder will be sent to all attendees. Do you confirm?",
  sendReminder: "Send reminder notification",
  sureToApprove: "Are you sure to confirm?",
  sureToReject: "Are you sure to reject?",
  voucherSend: "Vouchers will be sent to {number} attendees",
  delComment: "Are you sure to delete this comment?",
  cancelReg: "Are you sure to cancel this registration? This action is irreversible",
  checkins: "Check-in operations",
  autoCheckin: "Automatic check-in",
  serviceStat: "Service status",
  importExcel: "Import from Excel",
  start: "Start transfer",
  prescription: "Time out",
  sendCert: "Send certificate",
  system: "System",
  addOption: "Add an option",
  optionList: "Options:",
  noInfo: "Attendee information not found",
  sureToDelR: "Records will be deleted 1 month after created.",
  size: "Size",
  duration: "Duration",
  addedBr: "Added broadcasts",
  onlyPart: "Only visible to attendees",
  justPart: "Only attendees",
  open: "Public",
  addPack: "Add package",
  editHall: "Edit selected hall",
  standGallery: "Stand gallery",
  file: "File",
  answers: "Live voting answers",
  answer: "Answer",
  activeEvents: "ACTIVE EVENTS",
  reject: "Reject",
  loading: "Loading to storage server",
  failed_: "Could not upload to storage server",
  uploaded: "Uploaded to storage server",
  notRecorded: "Not recorded",
  certSettings: "Certificate settings",
  recording: "Recording",
  mailTitle: "E-mail title",
  mailLang: "E-mail language",
  mailContent: "E-mail content",
  vertical: "Vertical",
  horizontal: "Horizontal",
  partInfo: "Attendee information",
  noComment: "No attendees have yet commented on this post.",
  partRight: "Event participation rights",
  surveyUsage: "Survey usage",
  liveVotingUsage: "Live voting usage",
  listPartTag: "List attendees in this tag",
  noLike: "No attendees have liked this post yet.",
  listPartGroup: "List attendees in this group",
  reason: "Lost badge, Printer error, Tag problem, Incorrect registration, Update",
  closed: "Online registration is closed.",
  comments: "Comments",
  likes: "Likes",
  login: "Login",
  loginDesc: "To log in to the admin interface, log in with your user information explicitly created for the administrator login and sent to your e-mail.",
  forgotPass: "Forgot password",
  deleteSelected: "Delete selected",
  checkinSelected: "Check-in selected",
  checkinDate: "Check-in date",
  writeQuestion: "Type your question here",
  addCat: "Add category",
  incVat: "Vat included",
  checkpoint_: "Venue information",
  enterCCode: "Enter the coupon code here...",
  editText: "Edit this text",
  watchBroadcast: "Watch broadcast",
  no_data: "There is no data",
  newModule: "Add new module",
  register: "Register",
  register_text: "Complete your registration to log in to the administrator interface.",
  checkpoint_selection: "Control point selection",
  share_announcement: {
    preview: "Preview",
    soon: "Soon",
    text: "Enter your announcement..."
  },
  forgotPassword: {
    text: "Forgot your password?",
    text2: "You can change your password via the 'forgot password' e-mail.",
    button: "Reset password",
    resend: "Resend e-mail",
    confirm: "Confirm",
    resetCode: "Reset code",
    newPassword: "New password",
    newPassword2: "Retype new password"
  },
  paymentCancelInfo: "{n} registrations for this payment will be cancelled. This action is irreversible.",
  authorityGroup: {
    reports: "Reports",
    eventRegistration: "Event registration",
    selectAuthorizations: "Select authorizations"
  },
  registerInput: {
    password: "Account Password",
    password2: "Retype account password"
  },
  organisation: {
    subscriptionAlert: "You do not have any active subscription. Please visit the billing screen to start a new subscription.",
    overview: {
      title: "Overview",
      createEvent: "Create event",
      welcome: "Welcome",
      underReview: "Your account is under review",
      underReviewMsg: "Your organization account is under review. Once the accuracy of your information has been confirmed, your account will be activated.",
      accountConfirm: "Your account has been active.",
      accountConfirmMsg: "Good news! Your organization account has been approved. You can start creating and managing your events.",
      createNewEvent: "To create a new event.",
      createNewEventClick: "click here",
      creditCardAttention: "Attention",
      creditCardAttentionMsg: "You do not have any active credit card in your account.  Please add a credit card to use Holacon without any interruption.",
      addcreditCard: "To add a credit card",
      addcreditCardClick: "click here",
      creditCardAttention: "Attention",
      creditCardAttentionMsg: "We are unable to get payments from any of your existing cards. Please add an active credit card to continue to use Holacon.",
      addcreditCard: "To add a credit card",
      addcreditCardClick: "click here",
      whiteLabel: "White-label status",
      whiteLabelStatus: "Your White-label services are active",
      planPayment: "<b>{0} USD / per month.</b>",
      planPayment2: "<b>{0} USD / lifetime.</b>",
      upgrade: "Upgrade",
      hideInPackage: "Hide what's not in the package",
      showInPackage: "Show what's not in the package",
      cancel: "Cancel",
      create: "Create",
      events: "Events",
      unlimited: "Unlimited",
      participant: "Registrations",
      abstract: "Abstract",
      liveBroadcast: "Live broadcast",
      storage: "Storage",
      teamMember: "Team member",
      rate: "usage rate"
    },
    event: {
      event: "event",
      title: "Event",
      filter: "Filter / Search",
      placeholder: "Search...",
      events: "Events",
      createEvent: "Create event",
      cancel: "Cancel",
      create: "Create",
      dateVenue: "Date / Venue",
      showArchive: "Show archived"
    },
    team: {
      title: "Team",
      authorize: "Authorize",
      authorizeMsg: "Enter the <b>user's e-mail</b> address of the user to authorize,  select the <b>events</b> and <b>authorization group</b> then click the <b>'Add'</b> button.",
      authorizeEmail: "E-mail",
      authorizeEvent: "Events",
      authorizeGroup: "Authorized group",
      team: "Team",
      addMember: "Add",
      addMemberNew: "Add a new team member",
      mainUserAuthorize: "Main user authorities cannot be changed.",
      coOwnerUserAuthorize: "Co-owner user authorities cannot be changed.",
      placeholderEvents: "Select Events",
      placeholderAuthorityGroup: "Select Authorized Group",
      update: "Update",
      events: "events",
      authorityGroups: "Authorized groups",
      addGroup: "Add group",
      numberAuthorize: "authorize",
      numberAuthorizePerson: "person",
      edit: "Edit",
      delete: "Delete",
      waitingApproval: "Waiting for approval",
      teamMember: "Team member",
      authority: "Authority",
      status: "Status"
    },
    profile: {
      title: "Profile",
      updateCoverPhoto: "Update cover photo (Must be in size 1120x500)",
      update: "Update",
      updateMax: "Must be in size 500x500",
      cancel: "Cancel",
      updateProfile: "Update profile",
      organisationName: "Organization name",
      about: "About",
      organizasyonType: "Organization type",
      email: "Email",
      mobile: "Mobile",
      phone: "Phone",
      address: "Address",
      loading: "Loading..."
    },
    integration: {
      title: "Integration",
      build: "Create an integration",
      buildMsg: "Are you interested in integrating your product with Holacon? Submit your product here.",
      buildLink: "Contact us",
      request: "Suggest Integration",
      requestMsg: "Don't see the integration you are looking for? Let us know, and we'll add it to our list of future developments.",
      requestLink: "Contact us",
      requestAPI: "Request API access",
      requestAPIMsg: "Please contact our development team if you would like to access our API library.",
      requestAPILink: "Contact us",
      paymentMethods: "Payment Methods",
      noDataPaymentMethod: "There is no payment method. You can add a payment method by clicking the “Add” button.",
      add: "Add"
    },
    billing: {
      freePayment: "Free",
      close: "Close",
      title: "Billing",
      plans: "Plans",
      currentPlan1: "Your organization is currently using",
      currentPlan2: "plan.",
      freePlan: "Free plan",
      freePlanStart: "You are currently using the freemium plan.",
      freePlanStop: "You can switch to the freemium plan to stop usage.",
      toFreeText1: "",
      toFreeBtn: "Click",
      toFreeText2: " to switch to the freemium plan",
      viewPackage: "Show packages",
      annualPurchases: "Save 2 months on annual purchases",
      month: "Month",
      year: "Year",
      buy: "Buy",
      cancelCancelSubscriptionTitle: "Do you want to continue your subscription?",

      cancelSubscriptionTitle: "Do you want to cancel the subscription?",
      //  aylık yıllık paketler gelecek

      toCancelText1: "",
      toCancelBtn: "Click",
      toCancelText2: " to cancel your current subscription",

      toCancelToCancelText1: "Your current subscription is in the cancellation process,",
      toCancelToCancelBtn: "click",
      toCancelToCancelText2: " to cancel the process and continue using it.",
      enterprise: "Enterprise",
      currentPlanUsing: "Your organization is currently using <b>{0}</b> plan.",
      specialOfferText1: "Do you need anything else than the predefined subscription packages?",
      specialOfferText2: "You can take advantage of the special offers we will prepare for you.",
      specialOfferBtn: "Click",
      specialOfferText3: " to contact",
      contactUs: "Contact us",
      changePlan: "Change plan",
      registerCards: "Payment methods",
      primaryPaymentCard: "Your organization currently uses the <b>{0}</b> card as its primary payment method.",
      noPrimaryCard: "You don't have any credit card defined for payment.",
      primaryCard: "Primary card",
      makePrimary: "Set this card as the primary",
      incorrectOperation: "Incorrect transaction",
      cardFamily: "Card Family",
      operation: "Operation",
      makePrimaryCard: "Make primary card",
      cardNo: "Bin",

      paymentHistory: "Payment History",
      successPaymentText1: "Your last successful payment is on",
      successPaymentText2: "",
      noSuccessPayment: "You don't have any successful payments yet.",
      preparing: "Preparing",

      paymentHistoryPayment: "Payment",
      paymentHistoryPlan: "Plan",
      paymentHistoryAmount: "Amount",
      paymentHistorySituation: "Situation",
      paymentHistoryInvoice: "Invoice",

      invoiceReceipt: "Invoice / Receipt information",
      noInvoice: "You don't have any billing information yet.",
      invoiceUpdateDate: "Your billing information was last updated on <b>{0}</b>.",
      organizationType: "Organization Type",
      companyName: "Company name",
      nameSurname: "Name, Surname",
      taxOffice: "Tax Office",
      idNo: "Identitfy No",
      taxNo: "Tax Number",
      country: "Country",
      city: "City",
      zipCode: "Postcode",
      address: "Address",
      save: "Save",

      newCard: "New card",
      cvv: "CVV",
      cancel: "Cancel",
      subscribe: "Subscribe",
      payYear: "Pay yearly",
      payMonth: "Pay monthly",

      plan: "Plan",
      planMsg: "You can browse subscription packages to upgrade your plan.",
      planInfo: "You can use the <b>{0}</b> packages you will purchase in all activities related to your organization.",
      planAttention: " You cannot purchase additional packages in free subscriptions. You must subscribe to any plan to purchase additional packages.",
      buy: "Buy",
      buyMsg: "Click to try shooting again.",
      piece: "Piece",
      download: "Download",
      subscriptionPackage: "Subscription Package :",
      amount: "Amount:",
      disconts: "Discounts :",
      taxes: "Taxes :",
      total: "Total :",
      cancel2: "Cancel",
      accept: "Accept",
      alreadySubscribe: "Subscribed",
      beSubscribe: "Subscribe",
      ok: "OK",
      packageAdded: "The package you bought has been added to your current plan.",
      paymentSuccess: "Your payment has been taken successfully!",
      subscriptionUpdated: "Your subscription plan has been updated",
      paymentFailed: "Payment could not be completed!",
      selectCard: "Please select the card you want to pay.",
      approveContracts: "Make sure you have approved the contracts.",
      editInfo: "Please edit your invoice information from bottom."
    }
  },
  homeMenu: {
    account: "Account",
    organization: "Organization",
    createOrganization: "Create Organization",
    statutory: "Legal",
    terms: "Terms of Use",
    privacyPolicies: "Privacy Policies",
    gdprText: "GDPR Clarification Text",
    cookies: "Use of Cookies",
    application: "Application",
    recommendFriend: "Recommend to friend",
    sendFeedback: "Send feedback",
    rateUs: "Rate the app",
    help: "Help",
    checkHolacon: "Discover Holacon",
    organizationName: "Organization name",
    eventType: "Event types",
    userExpMsg: "We improve your user experience in line with your preferences.",
    organizationType: "Organization Type",
    requiredBilling: "Required for billing processes.",
    companyName: "Company name",
    nameSurname: "Name Surname",
    taxOffice: "Tax Office",
    taxNo: "Tax Number",
    idNo: "Identitfy no",
    requiredInvoice: "Required for invoice processing",
    address: "Address",
    country: "Country",
    city: "City",
    questionFind: "How did you find us?",
    cancel: "Cancel",
    create: "Create",
    password: "Password",
    delete: "Delete",
    organizationDelete: "Please enter the password of the organization owner account.",
    deleteOrganizationTitle: "Delete organization"
  },

  totalContent: "Showing total of <b>{0}</b> result(s).",

  contentManagement: {
    eventProgram: {
      event: "Event",
      ratings: "Ratings",
      days: "Days",
      saloons: "Halls",
      addProgram: "Add Program",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      speaker: "Speaker",

      allSaloons: "All halls",
      showSubEvent: "Programs related to the {0} subevent",
      review: "Review",
      sendReminderNotification: "Send reminder notification",
      avarage: "Average",
      addProgram: "Add program",
      editProgram: "Edit program",
      ratings: "Ratings",

      components: {
        title: "Title",
        date: "Date",
        viewing: "Show",
        placeholderPickDay: "Select a day",
        delete: "Delete",
        cancel: "Cancel",
        deleteSureMsg: "Event schedules of this day will also be deleted. Are you sure to continue?",
        close: "Close",
        addDay: "Add day",
        color: "Color",
        addSaloon: "Add hall",
        save: "Save",
        sendReminder: "Send reminder",

        session: "Session",
        includesTitleContent: "Includes title and content",
        subEvent: "Sub-event",
        createSessionSubEvent: "Create a session for the subevent.",
        section: "Section",
        sessionGroup: "Includes a specific session group",
        break: "Break",
        breakMsg: "Coffe break, lunch break, etc.",

        subeventSelection: "Sub-event selection",
        subEventPublishInfoMsg: "The day you will create is published in the day selection you choose in this section.",
        programTitleMsg: "It is published as the title of your program in your program flow.",
        saloonSelection: "Hall selection",
        defineSaloonMsg: "Defines the hall where the program will take place",

        daySelection: "Day selection",
        defineDayMsg: "It defines the day(s) the program will take place.",
        startTime: "Start time",
        startTimeMsg: "It defines the start time of the program.",
        endTime: "End time",
        endTimeMsg: "It defines the end time of the program.",
        calculateTime: "Total duration of the session",
        calculateTimeMsg: "It automatically calculates the total time of the program.",

        content: "Content",
        contentDetails: "You can enter detailed information about the content of the program.",
        badgeSelect: "Badge selection",
        badgeSelectMsg: "It is used to describe the break type visually.",
        speakers: "Speakers",
        speakersMsg: "You can add a presentation or speaker to the program detail.",
        speakerPresenter: "Speaker / Moderator",
        timeMinutes: "Time (Min)",

        selectSpeaker: "Select speaker.",
        searchSpeaker: "Search speaker",
        selectMin: "Select minutes",
        chooseStartTime: "Choose start time",
        addNotice: "Add abstract submission",
        addSpeaker: "Add speaker",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        viewingMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        tags: "Tags",
        reminderNotificationMsg: "A reminder notification will be sent to the attendees.",
        specifyTime: "Indicate time",
        chooseTime: "Select time",
        noSpeakerMsg: "No speakers have been added yet."
      }
    },
    speakers: {
      addSpeaker: "Add speaker",
      editSpeaker: "Edit speaker",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      speaker: "Speaker",
      viewing: "Publish",
      searchFilter: "Search / Filter",
      speakerAddUpdate: {
        nameSurname: "Name & Surname",
        NamaSurnameMsg: "The speaker's name and surname are written. Attendee can view.",
        title: "Title",
        company: "Company",
        email: "Email",
        emailMsg: "Email is not shared with attendees",
        bio: "Biography",
        pic: "Picture",
        orderNo: "Order No",
        picMsg: "Please upload a 500 x 500 photo.",
        presentations: "Presentations",
        presentationsMsg: "You can enter multiple presentation topics. ",
        addPresentations: "Add presentation",
        links: "Links",
        linkMsg: "You can add links to the speaker's social media accounts, website, etc. Attendees can view these in the speaker profile.",
        settings: "Settings",
        settingsMsg: "You can make changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        presentationTitle: "Presentation title",
        close: "Close",
        delete: "Delete",
        save: "Save",
        incorrectFields: "There are {0} incorrect fields"
      }
    },
    sponsors: {
      addCategory: "Add category",
      editCategory: "Edit category",
      addSponsor: "Add sponsor",
      editSponsor: "Edit sponsor",
      sponsorAddUpdateAndCategoryAddUpdate: {
        pic: "Picture",
        picMsg: "Please upload a 500 x 500 photo.",
        title: "Title",
        titleMsg: "Enter a title for the sponsor. It will be published as the name of the sponsor.",
        titleMsgCat: "Enter a category title. It will be published as the name of the sponsor category.",
        link: "Link",
        linkMsg: "Clicking on the sponsor image will open the link you entered.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        close: "Close",
        delete: "Delete",
        save: "Save",
        uploadText: "Drop file here or <em>click to upload</em>",
        imageSize: "Image size",
        imageSizeMsg: "It determines the size of the sponsor images that will be grouped under the category."
      }
    },
    stands: {
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchFilter: "Search / Filter",
      placeholderStand: "Search stand...",
      stand: "Booth",
      broadcast: "Show",
      addStand: "Create a booth",
      editStand: "Edit booth",
      standAddUpdate: {
        title: "Title",
        titleMsg: "Enter a title for the booth. The title will be published as the booth name.",
        saloon: "Hall",
        updateHallList: "Update hall list",
        //TODO Kemal beye soralım
        saloonMsg: "Defines the hall where the stand is located.",
        orderNo: "Order No",

        logo: "Logo",
        logoMsg: "Please upload a 500x500 image.",

        cover: "Cover photo",
        coverMsg: "Please upload an image of 1120x500 size.",
        content: "Content",
        contentDetails: "The content you enter will be published as detailed information about the booth.",

        contact: {
          contact: "Contact",
          contactMsg: "You can add different communication channels for this booth.",
          addressInformation: "Address info",
          addressHeader: "Address title",
          addressHeaderMsg: "Enter a title to define your address information.",
          openAdres: "Open address",
          country: "Country",
          city: "City",
          mapLocation: "Location",
          searchLocation: "Search for location",
          searchLocationMsg: "Enable attendees to access the company location easily.",
          chooseLocation: "Choose location",
          chooseLocationMsg: "The location you enter will allow visitors to easily access the company address from the location on the map.",
          social: "Social media links",
          mobilePhone: "Mobile phone",
          phoneNumber: "Phone number",
          email: "Email"
        },
        links: {
          links: "Links",
          linkMsg: "You can add multiple links for the booth, such as social media accounts, websites, etc.",
          title: "Title",
          url: "Url",
          view: "Show",
          addLink: "Add Link",
          newLink: "New Link",
          noLinkMessage: "Link information is not available."
        },
        gallery: {
          gallery: "Gallery",
          galleryMsg: "You can add custom images, photos, and Youtube videos for visitors.",
          media: "Media",
          view: "Show",
          youtubeVideo: "Youtube video",
          photo: "Photo",
          addMedia: "Add Media",
          editMedia: "Edit Media",
          noGalleryMessage: "Gallery information is not available.",
          mediaComponent: {
            img: "Image",
            youtubeVideo: "Youtube video",
            title: "Title",
            titleMsg: "Enter a title for this media. It will be published as the name of the relevant media content.",
            view: "Show",
            viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
            // img: "Image",
            imgMsg: "Please a 800x600 image.",
            youtubeVideoUrl: "Youtube Url",
            youtubeVideoUrlMsg: "Please paste the URL of the video you got from the Youtube share section..",
            preview: "Preview",
            settings: "Settings",
            settingsMsg: "You can make any changes to the current settings related to the content.",
            close: "Close",
            delete: "Delete",
            save: "Save"
          }
        },
        authorities: {
          authorities: "Attendants",
          authoritiesMsg: "You can enable visitors to contact booth representatives or attendants at on-site and online events.",
          add: "Add",
          selectAuth: "Please select attendants",
          authorized: "Attendant",
          task: "Task",
          view: "Show"
        },
        checkinQuestions: {
          checkinQuestions: "Survey for Visitors",
          checkinQuestionsMsg: "You can prepare unique questions that booth visitors can answer during check-in and collect information."
        },
        settings: {
          settings: "Settings",
          settingsMsg: "You can make any changes to the current settings related to the content.",
          checkIn: "Check-in method",
          checkInMsg: "Depending on your event type, you can check in for your visitors digitally or by scanning their badges.",
          view: "Show",
          viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
          useTags: "Use tags",
          useTagsMsg: "You can use data tags to make content-related customizations in custom integrations."
        },
        close: "Close",
        delete: "Delete",
        save: "Save",
        incorrectFields: "There are {0} incorrect fields"
      },
      standSaloon: {
        title: "Title",
        color: "Color",
        view: "Show",
        close: "Close",
        addSaloon: "Add hall",
        editSaloon: "Edit hall",
        saloonStandAddUpdate: {
          title: "Title",
          titleMsg: "Please enter a title to specify the name of the hall.",
          color: "Color",
          colorMsg: "Please select a color to customize the hall visually.",
          settings: "Settings",
          settingsMsg: "You can make any changes to the current settings related to the content.",
          view: "Show",
          viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
          close: "Close",
          delete: "Delete",
          save: "Save"
        }
      },
      standCheckin: {
        close: "Close",
        download: "Download"
      }
    },
    networking: {
      addRoom: "Add room",
      room: "Room",
      view: "Show",
      people: "People",
      addNetworkRoom: "Add network room",
      editNetworkRoom: "Edit network room",
      networkingAddUpdate: {
        title: "Title",
        titleMsg: "Please enter a name for the network room to be published.",
        numberOfPeople: "Number of people",
        numberOfPeopleMsg: "It sets a attendee limit for the room.",
        cover: "Cover image",
        coverMsg: "Please upload a 1120x500 image.",
        backgroundImage: "Background image",
        backgroundImageMsg: "Please upload a 1920x1200 image.",
        authorities: {
          authorities: "Attendants",
          authoritiesMsg: "You can assign attendees as attendants in different roles to this room.",
          add: "Add",
          selectAuth: "Please select attendants",
          authorized: "Attendant",
          task: "Task",
          view: "Show",
          alreadyHas: "The attendee you want to add is already in the authorized list."
        },
        settings: {
          settings: "Settings",
          settingsMsg: "You can make any changes to the current settings related to the content.",
          view: "Show",
          viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms."
        },
        oneError: "There are incorrect areas.",
        control: "Access control automation",
        controlMsg: "You can perform access control operations and keep entry records with digital control points.",
        controlPoints: "Control points",
        controlPointsMsg: 'There is no controller defined for this networking room. To define a controller, you can specify the networking room by creating a new controller from the "control points" section.',
        controlPointsGo: "Go to control points",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    eventAlbum: {
      gallery: {
        gallery: "Album",
        addMediaForAlbum: "Add a media for album",
        photo: "Photo",
        addMedia: "Add Media",
        editMedia: "Edit Media",
        mediaComponent: {
          img: "Image",
          youtubeVideo: "Youtube video",
          title: "Title",
          titleMsg: "The title you specify will be published as the media name.",
          view: "Show",
          viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
          // img: "Image",
          imgMsg: "Please upload a min 800x600 image.",
          youtubeVideoUrl: "Youtube Url",
          youtubeVideoUrlMsg: "Please enter the Youtube URL copied from the share section of the video.",
          preview: "Preview",
          settings: "Settings",
          settingsMsg: "You can make any changes to the current settings related to the content.",
          close: "Close",
          delete: "Delete",
          save: "Save"
        }
      }
    },
    files: {
      addFolder: "Add folder",
      editFolder: "Edit folder",
      downloadDocument: "Download document",
      editDocument: "Edit document",
      deleteDocument: "Delete document",
      addDocument: "Add document",
      fileAddUpdate: {
        file: "File",
        fileMsg: 'Upload files in ".doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .gif, .txt, .jpg, .png" formats with a maximum size of 15 MB.',
        title: "Title",
        titleMsg: "Specify a file name to be published.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        close: "Close",
        delete: "Delete",
        save: "Save",
        reason: "Reason"
      },
      fileCategoryAddUpdate: {
        title: "Title",
        titleMsg: "The title you enter will be published as the file name.",
        color: "Color",
        colorMsg: "The title you enter will be published as the folder color.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    quaestionLibrary: {
      addQuestion: "Add question",
      editQuestion: "Edit question",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchFilter: "Search / Filter",
      question: "Question",
      view: "Show",
      quaestionLibraryAddUpdate: {
        title: "Question",
        titleMsg: "Please enter a question.",
        answer: "Answer",
        answerMsg: "Please enter an answer for the relevant question.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    areaMap: {
      addMap: "Add Map",
      editMap: "Edit Map",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchFilter: "Search / Filter",
      map: "Map",
      view: "Show",
      areaMapAddUpdate: {
        img: "Image",
        imgMsg: "Please upload an 800x600 image.",
        title: "Title",
        titleMsg: "Enter a title for your map.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        useTags: "Use tags",
        useTagsMsg: "You can use data tags to make content-related customizations in custom integrations.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    }
  },
  eventInfo: {
    logo: {
      description: "Upload a 500x500 logo image"
    },
    cover: {
      description: "Upload a 1120x500 cover image "
    },
    about: {
      title: "About event",
      informations: "Information",
      informationsMsg: "Enter detailed information about your event and its dates.",
      eventName: "Event name",
      eventNameMsg: "Enter an event name.",
      color: "Color",
      colorMsg: "The colour you define is adapted as the event's primary colour, and the applications are adapted according to this colour.",
      language: "Languages",
      languageMsg: "Define event languages.",
      timezone: "Timezone",
      timezoneMsg: "It identifies the time zone of the region where the event will be held. It allows attendees outside the time zone to correctly adapt the event date and time.",
      date: "Date",
      dateMsg: "Define the dates of the event based on the event start and end dates.",
      stardDate: "Start date",
      stardDateMsg: "Defines the start date of the event.",
      startTime: "Start time",
      startTimeMsg: "Defines the start time of the first day of the event.",
      endDate: "End date",
      endDateMsg: "Defines the end date of the event.",
      endTime: "End time",
      endTimeMsg: "Defines the end time of the last day of the event.",
      localization: "Localization",
      localizationMsg: "Set the localizations according to the local conditions of the region where the event will take place and the attendees.",
      dateFormat: "Date format",
      dateFormatMsg: "Sets the date format and displays in the attendee applications.",
      timeFormat: "Time format",
      timeFormatMsg: "Defines the time zone of the region where the event will take place. It allows attendees outside the time zone to correctly adapt the event date and time.",
      content: "Content",
      contentMsg: "Enter detailed information so your attendees can learn more about your event.",
      eventType: "Event type",
      eventTypeMsg: "Choose your event type - hybrid, online or onsite",
      category: "Category",
      categoryMsg: "Specify a category that tells about the scope and concept of your event.",
      about: "About",
      aboutMsg: "Share detailed information about your event and event goals with your attendees.",
      save: "Save"
    },
    location: {
      title: "Location, Contact, Social",
      addressTitle: "Address",
      addressTitleMsg: "By entering your complete address information, you can enable your attendees to come to the event venue easily.",
      venue: "Venue",
      venueMsg: "Enter the name and other helpful information of the venue where the event will take place.",
      address: "Address",
      addressMsg: "Enter the complete address information of the location where the event will take place.",
      country: "Country",
      countryMsg: "Enter the country where the event will take place.",
      city: "City",
      cityMsg: "Enter the city where the event will take place.",
      location: "Location",
      locationMsg: "You can assist your attendees with navigation access by entering the location of your event venue.",
      mapLocation: "Location",
      mapLocationMsg: "It defines the map location of where the event will take place. Thanks to this information, attendees can easily create routes through navigation applications."
    },
    contact: {
      contact: "Contact",
      contactMsg: "Enter your contact information so that your attendees can easily contact your team."
    },
    social: {
      social: "Social",
      socialMsg: "You can add your social media accounts to increase your interaction about your event and reach more people in your social media account."
    },

    settings: {
      title: "Settings",
      settings: "Settings",
      settingsMsg: "You can adapt Holacon to your event content and program by changing the basic settings.",
      autoCheckin: {
        title: "Automatic check-in",
        description: "Attendees with a QR Code, Voucher, or Name Badge can use them to pass directly from the access control points. When this option is activated, the system automatically performs check-in during the first scanning of the codes of the attendees."
      },
      interaction: {
        interaction: "Interaction",
        interactionMsg: "You can adapt Holacon according to your event's content, concept, and program by making any changes in the interaction settings.",
        restrictSession: "Restrict session reviews & ratings",
        restrictSessionMsg: "When you restrict session ratings & reviews, the attendees cannot view them.",
        profileView: "Turn off profile access",
        profileViewMsg: "When you turn off this feature, attendees cannot access each other's profile information and interact in the apps."
      },
      save: "Save"
    },

    modules: {
      title: "Modules",
      modules: "Modules",
      modulesMsg: "You can edit and adapt the application modules according to the concept and content of your event and add Webview modules.",
      addModule: "Add Module",
      module: "Module",
      view: "Show",
      publishMsg: "Customize and publish your {0} module in the attendee apps.",
      save: "Save",
      moduleSettings: "Module settings",
      eventModuleUpdate: {
        en: "English",
        tr: "Türkçe",
        title: "Title",
        titleMsg: "Defines the name of the module.",
        url: "URL",
        urlMsg: "Enter the URL that the module will redirect the attendees.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, the attendees will not be able to view this module in apps and other digital platforms.",
        openInApp: "Open in app",
        openInAppMsg: "When you activate the option, the link you added will open in the application.",
        onlyAttendees: "Only attendees can access",
        onlyAttendeesMsg: "When you activate this option, app visitors who don't register for your event cannot view this module on applications.",
        close: "Close",
        delete: "Delete",
        save: "Confirm",
        type: "Type",
        text: "Text",
        textMsg: "Defines the content of the module.",
        tag: "Tags",
        tagMsg: "Only participants with this tag can view this module."
      }
    },

    widgets: {
      title: " Widgets",
      widgets: "Widgets",
      widgetsMsg: "You can publish your event content on digital channels such as websites with embedded JS codes by using ready-to-use widgets on digital channels such as websites etc.",
      registration: "Registration form",
      registrationMsg: "You can customize your event registration forms and publish them on any digital channel.",
      program: "Program",
      programMsg: "You can customize your event program and publish it on any digital channel.",
      speakers: "Speakers",
      speakersMsg: "You can customize your event speakers and publish them on any digital channel.",
      sponsor: "Sponsors",
      sponsorMsg: "You can customize your event sponsors and publish them on any digital channel.",
      foyer: "Foyer",
      foyerMsg: "You can customize your event foyer areas and publish them on any digital channel.",
      album: "Album",
      albumMsg: "You can customize your event albums and publish them on any digital channel.",
      faq: "Frequently asked questions",
      faqMsg: "You can customize your event FAQ and publish them on any digital channel.",
      social: "Social hub",
      socialMsg: "You can customize your social hub and publish it on any digital channel.",
      vote: "Vote",
      voteMsg: "You can customize your live voting screens and publish them on any digital channel.",
      poll: "Survey",
      pollMsg: "You can customize your surveys and publish them on any digital channel.",
      soon: "Soon",
      save: "Save"
    }
  },
  onsiteUtilities: {
    digitalCertificate: {
      create: "Create certificate design",
      certificateName: "Specify a name for the certificate.",
      certificateNamePlaceholder: "Certificate name",
      expriryDate: "By setting an expiry date for your certificates, you can ensure that your credentials are valid until a specific date..",
      expriryDatePlaceholder: "Expiry date",
      save: "Save",
      cancel: "Cancel",
      saveSure: "Are you sure the changes will be saved?"
    },
    cardDesigner: {
      createCardDesign: "Create badge design",
      editCardDesign: "Edit badge design",
      cardDesigns: "Badge designs",
      card: "Badge",
      view: "Show",
      addUpdate: {
        title: "Title",
        titleMsg: "Enter a title to identify your badge design.",
        variable: "Variables",
        variableMsg: "The variables you insert into the badge design will be filled automatically according to the attendee information during the printing process.",
        addBg: "Add background",
        editBg: "Delete background",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot view this content in apps and other digital platforms.",
        printBg: "Print background",
        printBgMsg: "It allows the background image you add to be sent to the printer as an image. Otherwise, the background is only used as a guide.",
        textCustomization: "Text customization",
        textCustomizationMsg: 'Capitalization is not taken into account. e.g., When the lowercase "i" is written as a capital "İ" letter, it is sent to the press as "İ".',
        textCustomizationMsg2: "It automatically customizes the variables in text format to a certain standard.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    controlPoints: {
      createControlPoint: "Create control point",
      editControlPoint: "Edit control point",
      title: "Title",
      controlType: "Control type",
      view: "Show",
      seatingArrangement: "Seating arrangement",
      allTags: "All tags",
      selectedTags: "Selected tags",
      selectedTitle1: "Selected sub-event registrations",
      selectedTitle2: "are allowed to join selected live sessions.",
      selectedTitle3: "They are allowed to join selected networking rooms.",
      vanueAddUpdate: {
        title: "Title",
        titleMsg: "Specify a title for the controller.",
        controllerType: "Controller type",
        controllerTypeMsg: 'You can define access control on the relevant platforms according to your chosen controller type. E.g., "Digital control" only controls areas such as live sessions and networking rooms.',
        controlType: "Control type",
        controlTypeMsg: "It enables restrictions for access control according to attendee group and participation type.",
        message1: "No tags for this group found.",
        message2: "Can access selected live sessions",
        message3: "Can access selected live networking rooms",
        assignedCheckpoint: "Previously assigned control point",
        note: "Note",
        noteMsg: "The information text about the control point can be viewed by the person who checked it.",
        settings: "Settings",
        settingsMsg: "You can make changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
        timeRestriction: "Time restriction",
        timeRestrictionMsg: "You can set this control point to run between certain hours. When you activate the option, the controller will not allow access except for the relevant time interval.",
        startTime: "Start time",
        endTime: "End time",
        specifyTime: "Select time",
        close: "Close",
        delete: "Delete",
        save: "Save"
      },
      accessLogs: {
        close: "Close",
        download: "Download"
      }
    },
    promotions: {
      close: "Close",
      download: "Download",
      reset: "Reset",
      searchFilter: "Search / Filter",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchPlaceholder: "Search...",
      attendee: "Attendee",
      promotions: "Promotions",
      authorized: "Authorized",
      quantity: "Quantity",
      addPromotion: "Add promotion",
      editPromotion: "Edit promotion",
      title: "Title",
      stockDistributed: "Distributed / Stock",
      remainder: "Remaining stock",
      view: "Show",
      promotionAddUpdate: {
        title: "Title",
        titleMsg: "Specify a title to name the promotion group.",
        stock: "Stock",
        stockMsg: "Enter the stock number. The stock quantity determines how many products will be distributed.",
        note: "Note",
        noteMsg: "The informational text about the promotion can be reached only by the attendant distributing the promotion.",
        limitations: "Restrictions",
        limitationsMsg: "It ensures that the promotion is distributed only to the attendees in a specific segment.",
        limitationsNotFound: "No tags found for this group.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",

        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    }
  },
  automatedMessages: {
    submissionHistory: "Delivery history",
    addNewDraft: "Add new draft",
    noDataThisCategory: "No data was found for this category.",
    addVoucher: "Add voucher",
    editVoucher: "Edit {0}",
    scheduleReminder: "Schedule reminder",
    automaticMessageRecords: "Automated message records",
    edit: "Edit {0}"
  },
  liveSessions: {
    live: "Live",
    waiting: "Waiting",
    cloudDesc: "It must be “active” to save the broadcast. The archiving feature has an additional cost, and your plan must include it. You cannot update this setting after the broadcast has started.",
    activationDesc: "When the live broadcast is activated, attendees can join the session and watch the broadcast.",
    liveActive: "Activate live broadcast?",
    important: "Important Information",
    importantDesc: "To provide a better event experience to your attendees during the event, we recommend that your speakers use an Ethernet cable for an internet connection. Connections made over Wi-Fi can cause instant internet problems and delays. We recommend checking connection permissions and controls in advance to avoid any access problems for speakers using private in-house internet. The recommended browser for speakers is the current version of Chrome.",
    importantDesc_: "To broadcast as a speaker from Apple devices, the use of the current version of Safari is mandatory.",
    statusDesc: "Passive sessions cannot be viewed by speakers and attendees.",
    vimeoSesions: "Vimeo Sessions",
    electedSpeaker: "Selected as speakers",
    rtmpTitle: "Streaming transfer through RTMP",
    rtmpDesc: "You can use a room-specific RTMP address to stream from a private broadcast source. You must not add speakers to the room to use the URL.",
    rtmpMessage: "RTMP Link copied successfully.",
    rtmpCopy: "Click to copy",
    searchFilter: "Search / Filter",
    filter: "Filter",
    filterMsg: "Narrow your search with the filter options.",
    searchPlaceholder: "Search / Filter",

    broadcastRecordings: "Live session recordings",
    addSession: "Add session",
    liveSession: "Live session",
    startEnd: "Start / End",
    duration: "Duration",
    speakersForBroadcast: "Speakers assigned for this session",
    speaker: "Speaker",
    liveSessionManagament: "Live session management",
    createLiveSession: "Create live session",
    createLiveStream: {
      placeholderChooseHour: "Specify time",
      placeholderChooseDate: "Select date",
      holaconMsg: "Use Holacon's broadcast infrastructure for easy, practical, and high-quality broadcasts!",
      rtmpMsg: "Stream from Yolobox, OBS, StreamYard, ReStream.io etc.",
      vimeoMsg: "Add sources such as Vimeo, YouTube.",
      zoomMsg: "Use Zoom integration.",
      soon: "Coming soon!",
      title: "Title",
      titleMsg: "Enter a title for the broadcast room.",
      startDate: "Start date",
      startDateMsg: "Enter a start date for this broadcast.",
      startTime: "Start time",
      startTimeMsg: "Enter a start time for the broadcast.",
      endDate: "End date",
      endDateMsg: "Enter an end date for this broadcast.",
      endTime: "End time",
      endTimeMsg: "Enter an end time for this broadcast.",
      coverImg: "Cover image",
      coverImgMsg: "Upload an image with a width of 1120 pixels and a height of 500 pixels.",
      close: "Close",
      save: "Save"
    },
    editLiveStream: {
      placeholderAddSpeaker: "Add speaker...",
      placeholderNameDesign: "Enter a name for your design.",
      server: "Sunucu",
      serverKey: "Yayın anahtarı",
      information: "Information",
      speakers: "Speakers",
      broadcastTitle: "Broadcast",
      scenesTitle: "Stages",
      settingsTitle: "Settings",
      info: {
        placeholderChooseHour: "Specify time",
        placeholderChooseDate: "Select date",
        title: "Title",
        titleMsg: " Enter a title for your live session. It will be displayed as the name of the broadcast/session in the program.",
        startDate: "Start date",
        startDateMsg: "Please select a start date for this session.",
        startTime: "Start time",
        startTimeMsg: "Please select a start time for this session.",
        endDate: "End date",
        endDateMsg: "Please select a end date for this session.",
        endTime: "End time",
        endTimeMsg: "Please select a end time for this session.",
        coverImg: "Cover image",
        coverImgMsg: "Please upload an image with a width of 1120 pixels and a height of 500 pixels.",
        imporantInformation: "Important information",
        imporantInformationMsg: "Click to look at the issues that need attention about the live broadcasts.",
        imporantInformationAll:
          "<p><b>For an uninterrupted and seamless live streaming experience:</b></p><p>• Ensure the speakers' internet connection has an uninterrupted minimum of 16 Megabit downloads and 8 Megabit uploads. These values are measured at lower values.</p><p>• Connections over Wi-Fi can cause instant internet problems and delays. It is recommended to connect computers broadcasting via Ethernet cable to the Internet.</p><p>• For speakers using an internet infrastructure with in-house special security procedures and restrictions, it is recommended that connection permissions and controls be made and rehearsed in advance to avoid access problems. </p><p>• The recommended browser for speakers who will broadcast on Windows is the current version of Chrome.</p><p>• To broadcast as a speaker from macOS devices, the use of the current version of Safari or Chrome is mandatory. </p><p>• To broadcast as a speaker from iOS devices, the use of the current version of Safari is mandatory.</p><p>• Using the current version of Chrome is mandatory to broadcast as a speaker from Android devices.</p><p>• Ensure that the device's camera, microphone, and screen-sharing access rights are given entirely.</p>"
      },
      speaker: {
        add: "Add",
        speaker: "Speaker",
        task: "Task",
        broadcast: "Broadcast"
      },
      broadcast: {
        streamFromSomething: "Stream from Yolobox, OBS, StreamYard, ReStream.io etc.",
        streamRtmp: "Broadcast streaming via RTMP",
        streamRtmpMsg: "You can use this room-specific RTMP address to stream from a private broadcast source. To use the URL, ensure you enter the stream source correctly, and don't forget to test streams.",
        preview: "Preview",
        title: "Title",
        titleMsg: "Indicates the names of the sources added to the broadcast room. For example: Original or translation",
        platform: "Platform",
        platformMsg: "The platform to which the resource will be transferred",
        source: "Source",
        sourceMsg: "Playback link to transfer the resource.",
        broadcast: "Broadcast",
        broadcastMsg: "Display status of the added resource.",
        addSource: "Add source",
        addSourceMsg: "Add sources such as Vimeo, YouTube.",
        addOneSource: "Add a source",
        noSpeaker: "No speakers have been added."
      },
      scenes: {
        headBanner: "Head banner",
        headBannerMsg: "1000 pixels width and 100 pixels height",
        bg: "Background",
        bgMsg: "1920 pixels width and 1200 pixels height",
        footBanner: "Sub banner",
        footBannerMsg: "1000 pixels width and 100p pixels height",
        save: "Save",
        newTemplate: "New template",
        createScene: "Create stage",
        success: "Choose a draft. When you save the draft, it is automatically published.",
        delete: "Delete",
        copy: "Copy"
      },
      settings: {
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",

        liveBroadcast: "Live broadcast",
        liveBroadcastMsg: "When the live session is activated, the attendees can watch the broadcast. While the live session is inactive, only speakers and moderators can join and rehearse this broadcast.",
        showViwer: "Show the number of audience",
        showViwerMsg: "There is no controller defined for this live session. To define a controller, you can create a new controller from the control points section and assign it to this live session.",
        checkpoint: "Control point",
        checkpointMsg: 'There is no controller defined for this live broadcast room. To define a controller, you can define the live broadcast room by creating a new controller from the "control points" section.',
        goCheckpoints: "Go to control points"
      },
      close: "Close",
      delete: "Delete",
      save: "Save"
    }
  },
  registrationManagement: {
    salesConfirmations: {
      participant: "Attendee",
      paymentInformation: "Payment Information",
      amount: "Amount",
      status: "Status",
      paymentIdDateSource: "Payment ID, Date, Source",
      amountCodePackage: "Amount, Code, Package",
      free: "Free",
      confirm: "Confirm",
      reject: "Reject"
    },
    registrationForm: {
      createForm: "Create form",
      registerationForm: "Registration form",
      packages: "Packages",
      services: "Services",
      view: "Show",
      registerationSpecialMsg: "Registration form processing has been closed. Registration cannot be performed through the form.",
      freeRegisteration: "Free registration",
      currency: "Currency:",
      currency2: "Currency",
      paymentMethod: "Payment Method",
      description: "Description",
      onlinePayment: "Online payments:",
      paymentBankTransfer: "Payments by bank transfer:",
      on: "On",
      off: "Off",
      editRegisterationForm: "Edit registration form",
      addRegisterationForm: "Add registration form",
      registerFormDialog: {
        search: "Search",
        formInformations: {
          tabName: "Form information",
          topMsg: "You can create special registration forms for your invited audience who will register for the event. For example, you can prepare a registration form with customized information and content for <b>Standard Registration</b>.",
          title: "Title",
          titleMsg: "The title you specify will be published as the name of the registration form.",
          language: "Language",
          languageMsg: "The language you choose determines the language in which the registration form will be displayed. If you have set the language as <b>English</b>, it is recommended to prepare the contents of the form according to this language.",
          topBanner: "Top banner",
          topBannerRecommend: "It is recommended to add an image with a width of 1120 pixels and a height of 100 pixels. The top banner will be located at the top of the registration form.",
          topBannerSureRemove: "Are you sure you want to remove the top banner?",
          uploadText: "Drop file here or <em>click to upload</em>",
          topBannerMaxSize: "You can upload a jpg or png image with a maximum size of 1 mb.",
          content: "Content",
          contentMsg: "The content you specify will be published as an informative text about the registration form.",
          subBanner: "Bottom banner",
          subBannerRecommend: "It is recommended to add an image with a width of 1120 pixels and a height of 100 pixels. The sub-banner will be located at the bottom of the registration form.",
          subBannerSureRemove: "Are you sure you want to remove the bottom banner?",
          subBannerMaxSize: "You can upload a jpg or png image with a maximum size of 1 mb."
        },
        paymentInformations: {
          tabName: "Payment information",
          topMsg: "You can make the necessary settings so that the registration, companion and additional services to be provided in the form you will create can be provided <b>paid</b> or <b>free</b>.",
          currency: "Currency",
          currencyMsg: "The currency determines the currency in which paid transactions made through the registration form will be processed.",
          taxName: "Tax name",
          taxSettings: "Tax settings",
          taxNameMsg: "The tax name defines the name of the tax applied for paid transactions made through the registration form.",
          taxRate: "Tax rate",
          taxRateMsg: "Tax rate calculates the rate of tax applied for paid transactions performed on the registration form. A percentage value must be entered.",
          onlinePayment: "Online payments",
          onlinePaymentMsg: "You can receive the registration fees as online payments by entering the bank POS defined in your organization account into this registration form.",
          paymentBankTransfer: "Payments by bank transfer",
          paymentBankTransferMsg: "By defining your bank information, you can receive registration fees by bank transfer (Wire Transfer / EFT) method.",
          test: "Test payment",
          addEditPayment: "Add/edit payment method",
          addPayment: "Add payment method",
          paymentMethod: "Payment method",
          currency: "Currency",
          setActive: "Set as active",
          freePaymentMsg: "Payment information for this registration form will remain free of charge. No fees can be entered."
        },
        packages: {
          tabName: "Packages",
          topMsg: "You can create <b>combined</b> or <b>single-day</b> packages with different options for the registration process to be presented in the form you will create. You can add different price options to the packages you create.",
          addPackage: "Add Package",
          registrationPackage: "Registration Package",
          stock: "Stock",
          price: "Price",
          view: "Show",
          free: "Free",
          edit: "Edit",
          delete: "Delete",
          pleaseAddOne: "Please add one package.",
          editPackage: "Edit package",
          addPackage: "Add package",
          deleteSure: "Are you sure to delete this?",
          addUpdateRegisterationPackage: {
            title: "Title",
            titleMsg: "The title you specify will be published as the package name.",
            segmentation: "Segmentation",
            segmentationMsg: "Creates a segment by identifying the people connected to the records made through this package to the tag you selected.",
            stock: "Stock",
            stockMsg: "Determines the registration limit to be applied for the package.",
            stockControl: "Stock control",
            stockControlMsg: "Based on the specified stock limit, it performs the control of the records according to the preferred method.",
            content: "Content",
            contentMsg: "The content you specify will be published as an informative text about the package.",
            pricing: "Pricing",
            pricingMsg: "You can apply different price options in various date ranges for the package to be created. <b>Standard</b> option in the first place is the fixed registration price of the package.",
            startDate: "Start date",
            endDate: "End date",
            price: "Price",
            view: "Show",
            free: "Free",
            chooseDate: "Choose a date",
            newPriceOption: "New price option",
            packageType: "Package type",
            packageMsg: 'The package to be created determines the participation days defined for the attendee, a special day can be defined for the package. <b>"One-day package"</b> allows only one of the specific days to be selected. <b>"Combined package"</b> provides participation on all days.',
            addNewDay: "Add new day",
            settings: "Settings",
            settingsMsg: "You can make any changes to the current settings related to the content.",
            viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
            situation: "Status",
            situationMsg: 'When you turn off the status option, the package cannot be used during registration, <b>"Out of stock"</b> will be displayed on the registration screen.',
            close: "Close",
            delete: "Delete",
            save: "Save"
          }
        },
        additionalServices: {
          tabName: "Additional services",
          tabName2: "Additional service categories",
          topMsg: "You can create <b>accommodation, transfer, product, stand area</b> and similar services and products with different options depending on the registration process to be presented in the form you will create.",
          addService: "Add service",
          editService: "Edit service",
          addCategory: "Add category",
          editCategory: "Edit category",
          service: "Service",
          stock: "Stock",
          price: "Price",
          view: "Show",
          free: "Free",
          deleteSure: "Are you sure to delete this?",
          edit: "Edit",
          delete: "Delete",
          specialQuestion: "Special questions",
          specialQuestionMsg: "You can create custom questions for additional service registration.",
          addUpdateRegisterationServices: {
            title: "Title",
            titleMsg: "The title you specify will be published as the stock name.",
            titleMsg2: "The title you specify will be published as the category name.",
            stock: "Stock",
            stockMsg: "Sets the enrollment limit for the additional service.",
            stockControl: "Stock control",
            stockControlMsg: "Based on the specified stock limit, it performs the control of the records according to the preferred method.",
            gallery: "Gallery",
            galleryMsg: "You must upload an image with a minimum width of 800 pixels and a height of 500 pixels. The images you will add will be published visually during additional service registration.",
            uploadText: "Drop file here or <em>click to upload</em>",
            uploadTextMsg: "jpg/png files smaller than 500 KB",
            tag: "Category",
            tagMsg: 'After naming the tag, you can create it by pressing the "Enter" key. The tags you add will be published as filters during additional service registration.',
            addTag: "+ Add tag",
            info: "Information",
            infoMsg: "The information you define will be published as text during additional service registration.",
            packageRestriction: "Package restriction",
            packageRestrictionMsg: "When you activate the restriction option, the additional service will only be available for registration in the packages you will define, if you define the mandatory option, registration will not be allowed without selecting the relevant additional service.",
            show: "Show",
            required: "Required",
            hide: "Hide",
            limitSettings: "Limit settings",
            limitSettingsMsg: "According to the selected packages, you can specify the maximum number of services you can receive depending on the record from each package.",
            package: "Package",
            limit: "Limit",
            settings: "Settings",
            settingsMsg: "You can make any changes to the current settings related to the content.",
            view: "Show",
            viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
            close: "Close",
            delete: "Delete",
            save: "Save"
          }
        },
        companionRegistration: {
          tabName: "Companion registration",
          tabName2: "Companion registrations",
          topMsg: "It allows users who register to the event with any package option to register with their companions. To use this feature, you need to open it using the button on the right.",
          companionRegistrationAlert: "Companion registration can only be preferred when purchasing registration package.",
          title: "Title",
          titleMsg: "The title you specify names the companion registration process. For example, you can name it as <b>Companions</b>.",
          price: "Price",
          priceMsg: "Determines the additional fee to be applied for each accompanying person added to the person record.",
          free: "Free",
          stock: "Stock",
          stockMsg: "Determines the registration limit to be applied for companions.",
          stockControl: "stock control",
          stockControlMsg: "Based on the specified stock limit, it performs the control of the companion records according to the preferred method.",
          packageRestriction: "Package restriction",
          packageRestrictionMsg: "You can define the companion records so that they can be processed according to the packages. If there is no restriction, all packages can be registered as a companion in the registration process.",
          show: "Show",
          required: "Required",
          hide: "Hide",
          limitSettings: "Limit settings",
          limitSettingsMsg: "According to the selected packages, you can specify the maximum number of services you can receive depending on the record from each package.",
          package: "Package",
          limit: "Limit",
          specialQuestion: "Special questions",
          specialQuestionMsg: "You can create custom questions for companion registration."
        },
        questionsAndInformation: {
          tabName: "Questions and information",
          couponCodes: "Coupon codes",
          couponCodesMsg: "You can provide discounts for users who register for the event with any package option, you can define code restrictions on packages."
        },
        couponCodes: {
          tabName: "Coupon codes",
          export: "Export",
          generateCode: "Generate code",
          title: "Title",
          definedPackage: "Defined Package",
          attachments: "Prefix / Suffix",
          codeLimit: "Code / Limit",
          reminderBtn: "Sending a reminder",
          show: "Show",
          code: "code",
          edit: "Edit",
          delete: "Delete",
          addEditCoupon: "Add/Edit Coupon",
          codeList: "Coupon list",
          noCoupon: "Coupon code not found.",
          addRegistrationCoupon: {
            title: "Title",
            titleMsg: "The title you specify defines the coupon code.",
            prefix: "Prefix",
            prefixMsg: "The prefix is the identification at the beginning of the coupon code. Allows identifying the code group.",
            suffix: "Suffix",
            suffixMsg: "Suffix is the identification at the end of the coupon code. Allows identifying the code group.",
            note: "Note",
            noteMsg: "You can enter a note for yourself in the code group.",
            couponSettings: "Coupon settings",
            couponSettingsMsg: "You can make changes to the current settings related to the content.",
            quantity: "Number",
            quantityMsg: "Determines the number of coupon codes to be generated within this code group.",
            limit: "Limit",
            limitMSg: "Determines the usage limit of each code generated within this code group.",
            discountType: "Discount type",
            discountTypeMsg: "Determines the type of discount for each code generated within this code group.",
            discountAmount: "Discount amount",
            discountAmountMsg: "Determines the total amount of discount for each code generated within this code group.",
            discountPercentage: "Discount percentage",
            discountPercentageMsg: "Determines the percentage of discount for each code generated within this code group.",
            status: "Status",
            statusMsg: "When you turn off the status option, the coupon code cannot be used by the guests during registration.",
            packageRestrictions: "Package restrictions",
            packageRestrictionsMsg: "When you turn this option off, attendees cannot use the coupon code on the registration screen.",
            registrationPackage: "Registration package",
            define: "Define",
            required: "Required",
            show: "Show",
            reminder: "Reminder",
            reminderMsg: "When you activate the reminder option, e-mails are sent to the defined person about the use of the coupon code.",
            nameSurname: "Name & Surname",
            nameSurnameMsg: "Name and surname of the person to whom the notification email will be sent.",
            email: "Email",
            emailMsg: "Notification email information to be sent.",
            close: "Close",
            delete: "Delete",
            save: "Save",
            placeholderTitle: "E.G: Welcome Discont",
            placeholderPrefix: "E.G: WELCOME-",
            placeholderSuffix: "E.G: -2022",
            placeholderNameSurname: "E.G: John Doe",
            placeholderNote: "E.G: This coupon code was created for special guests.",
            placeholderMail: "E.G: example@hotmail.com"
          },
          registrationCouponDetails: {
            copyCode: "Copy code",
            couponCode: "Coupon Code",
            copyLinkMsg: "Registration link copied.",
            copyCodeMsg: "Code copied.",
            limitUsage: "Limit / Usage",
            remainder: "Remaining",
            quickLink: "Quick registration link",
            copyLink: "Copy Link",
            close: "Close",
            download: "Download"
          }
        },
        contracts: {
          tabName: "Contracts",
          registerContract: "Registration Contracts",
          registerContractMsg: "Changes you will make in this field affect the operations in the registration form. We recommend being careful when making changes.",
          gdprContract: "GDPR Contract",
          gdprContractMsg: "When the contract is activated, it is added to the registration screen as a mandatory.",
          gdprTitle: "GDPR contract title",
          gdprTitleMsg: "The title you specify will be published as the contract title in the registration form.",
          gdprContent: "GDPR contract content",
          gdprContentMsg: "The content you specify will be published as the contract text in the registration form.",

          privacyPolicy: "Privacy Policy",
          privacyPolicyMsg: "When the contract is activated, it is added to the registration screen as a mandatory.",
          privacyPolicyTitle: "Privacy Policy contract title",
          privacyPolicyTitleMsg: "The title you specify will be published as the contract title in the registration form.",
          privacyPolicyContent: "Privacy Policy contract content",
          privacyPolicyContentMsg: "The content you specify will be published as the contract text in the registration form.",
          termsOfUse: "Terms of Use",
          termsOfUseMsg: "When the contract is activated, it is added to the registration screen as a mandatory.",
          termsOfUseTitle: "Terms of Use contract title",
          termsOfUseTitleMsg: "The title you specify will be published as the contract title in the registration form.",
          termsOfUseTitleContent: "Terms of use contract content",
          termsOfUseTitleContentMsg: "The content you specify will be published as the contract text in the registration form.",
          distanceSalesContract: "Distance Sales Contract",
          distanceSalesContractMsg: "The title you specify will be published as the contract title in the registration form.",
          distanceSalesContractTitle: "Distance sales contract title",
          distanceSalesContractTitleMsg: "The title you specify will be published as the contract title in the registration form.",
          distanceSalesContractContent: "Content of distance sales contract",
          distanceSalesContractContentMsg: "The content you specify will be published as the contract text in the registration form.",
          distanceSalesContractVariables: "Variables for distance sales contract",
          distanceSalesContractVariablesMsg: "You can only use these variables in the distance sales contract."
        },
        formSettings: {
          tabName: "Form settings",
          formSettings: "Form settings",
          formSettingsMsg: "Changes you will make in this field affect the operations in the registration form. We recommend being careful when making changes.",
          formStock: "Limit",
          formStockMsg: "Please specify the maximum registration number that the form can receive",
          groupRegistration: "Group registration",
          groupRegistrationMsg: "Allows attendees to make group registration and ticket purchases by adding more than one person while registering.",
          minAttandee: "Minimum attendee",
          maxAttendee: "Maximum attendee",

          transaction: "Transaction and receipt information",
          transactionMsg: "In the Payments & Confirmations section, it is registered as the person who made the transaction and is responsible for it. If the transaction information is closed, the contact information of the 1st attendee is saved as the transaction information and detailed invoice information are not received. We do not recommend closing this option.",
          automaticConfirmation: "Automatic confirmation",
          automaticConfirmationMsg: "When this option is activated, sales and related registrations are automatically approved by the system.",
          autoVoucher: "Auto voucher",
          autoVoucherMsg: "When this option is activated, an automatic Voucher is sent to the attendees whose registration is automatically approved by the system.",
          status: "Status",
          statusMsg: 'When you turn this option off, you cannot get any registrations  and <b>"Registration has expired"</b> will be displayed on the screen.',
          show: "Show",
          showMsg: 'When you turn this option off, attendees cannot view and access this content. Forms sent via a private link can be registered as long as the <b>"Status"</b> option is active.'
        },
        close: "Close",
        delete: "Delete",
        saveContract: "Save contract information",
        saveFormInfo: "Save form information",
        savePaymentInfo: "Save payment information",
        saveCompanionSettings: "Save companion settings",
        saveFormSettings: "Save form settings"
      }
    },
    subeventRegistrations: {
      records: "Records",
      createSubevent: "Create sub-event",
      searchFilter: "Search / Filter",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchPlaceholder: "Search...",

      subevents: "Sub-events",
      title: "Title",
      capacityMsg: "Specify a maximum attendee capacity for the sub-event.",
      capacity: "Capacity",
      mobileRegisterMsg: "This option allows attendees to register for sub-events free of charge via applications.",
      mobileRegister: "Mobile registration",
      view: "Show",
      active: "Active",
      passive: "Passive",
      notRequire: "Does not require confirmation",
      require: "Requires confirmation",
      subeventRegistration: "Sub-event registrations",
      subeventAddUpdate: {
        title: "Title",
        titleMsg: "Enter a name for this sub-event",
        content: "Content",
        selectAll: "Select all",
        contentMsg: "Enter content that will inform your attendees about this event in detail.",
        tagRestriction: "Tag restriction",
        tagRestrictionMsg: "It determines the people in the segment who can register via the mobile application. Attendees other than the specified tags cannot register.",
        registrationTag: "Registration tag",
        registrationTagMsg: "It determines the attendee's registration status for the sub-event.",
        registrationQuestions: "Registration questions",
        registrationQuestionsMsg: "You can add additional questions to the registration form and customize it for your attendees.",
        registrationAutomation: "Registration automation",
        registrationAutomationMsgPrd: "By using the registration automation option, you can get automatic registrations for this product. If you define a sales package or additional service, the relevant product is automatically defined to the attendee who purchases the defined package or additional service.",
        registrationAutomationMsg: "By using the registration automation option, you can get automatic registrations for this sub-event. If you define a sales package or additional service, the attendee who purchases the defined package or additional service is automatically registered in the relevant sub-event.",
        packaceBased: "Include in a package",
        additionalServiceBased: "Include in a additional service",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
        limit: "Limit",
        limitMsg: "This option allows you to limit the registration for the sub-event. Registration requests are automatically rejected when the participation limit is complete.",
        limitMsgPrd: "This option allows you to limit the registration for the product. Registration requests are automatically rejected when the participation limit is complete.",
        stock: "Attendance limitation",
        stockMsg: "This option sets the maximum number of attendees that can join this sub-event.",
        stockControl: "Attendance control",
        stockControlMsg: "It checks the records according to the preferred access control method based on the specified participation limit.",
        mobileRegisters: "Mobile registrations",
        mobileRegistersMsg: "When you activate this option, attendees can register for this sub-event free of charge via the mobile application.",
        automaticConfirmation: "Automatic confirmation",
        automaticConfirmationMsg: "When you activate this option, the registrations submitted through the mobile application are automatically confirmed.",
        controlCenter: "Control point",
        controlCenterMsg: "There is no controller defined for this sub-event. To define a controller, you can create a new controller from the 'Control points' section and assign it to a sub-activity.",
        goControlCenter: "Go to Control points",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    additionalProducts: {
      records: "Records",
      createProduct: "Create product",
      searchFilter: "Search / Filter",
      filter: "Filter",
      filterMsg: "Narrow your search with the filter options.",
      searchPlaceholder: "Search...",

      title: "Products",
      capacityMsg: "Specify a maximum attendee capacity for the sub-event.",
      capacity: "Capacity",
      view: "Show",
      headerTitle: "Title",
      productRecords: "Product records",
      dialog: {
        title: "Title",
        titleMsg: "Enter a name for this product",
        content: "Notes",
        contentMsg: "Example Text"
      }
    }
  },
  participantManagament: {
    registrationSearch: {
      detailsParticipant: {
        warning: "Warning",
        deleteYes: "Yes, delete",
        blockYes: "Yes",
        blockCancel: "Block canceled.",
        deleteCancel: "Delete canceled.",
        cancel: "Cancel",
        deleteParticipant: "Are you sure to delete?",
        blockParticipant: "Are you sure to block?",
        unBlockParticipant: "Are you sure you want to unblock?",
        activationCodeRefresh: "Your activation code has been reset.",
        additionalProduct: "Product",
        additionalProductName: "Product name",
        free: "Free",
        update: "Update",
        useCam: "Use camera",
        updatePhoto: "Upload photo",
        submission: "Send",
        sendVoucher: "Send voucher",
        sendCertificate: "Send certificate",
        edit: "Edit",
        operations: "Operations",
        printCard: "Print badge",
        checkin: "Check-in",
        addProxy: "Add proxy attendee",
        block: "Block",
        unblock: "Unblock",
        editInformation: "Edit information",
        deleteRegistration: "Delete registration",
        paymentPendingConfirmation: "Payment pending confirmation",
        paymentPendingConfirmationMsg: "One or more payments of this attendee are pending approval. If not approved, they cannot benefit from the rights related to the registration.",
        free: "Free",
        confirm: "Confirm",
        proxyAppointed: "Proxy attendee has been assigned",
        proxyAppointedMsg: "Since a proxy attendee has been assigned to this attendee, the rights have been transferred to the proxy attendee. Registration-related transactions, such as badge printing, check-in, etc., cannot be performed, and the person cannot enter the event areas. The person assigned as a proxy can use these rights and check in.",
        assignedBy: "assigned by",
        dayRestriction: "Day restriction",
        dayRestrictionMsg: "As the attendee's registration is on a different day from this day, it cannot be checked in. If the badge is printed, the attendee cannot pass through the control points.",
        participationDays: "Participation days:",
        participantBlocked: "Attendee blocked",
        participantBlockedMsg: "You cannot print a badge or check in because the attendee is blocked. The attendee cannot pass through the control points in the event area.",
        paymentPending: "Pending payment",
        paymentPendingMsg: "Pending for a payment registration to be defined for one or more products belonging to the attendee. The relevant rights will only be granted by defining the payment registration.",
        addPayment: "Add payment",
        watingForApporval: "Pending approval",
        watingForApporvalMsg: "One or more additional services related to the attendee's registration are waiting for approval. If it is not approved, the attendee will not be able to benefit from the relevant services.",
        accompany: "Companion",
        additionalServices: "Additional services",
        paymentsDeclined: "Payments rejected",
        paymentsDeclinedMsg: "This attendee's payment has been rejected. Since they do not have a package to enter the event area, you cannot print a badge or check-in for this attendee, and the attendee cannot enter the event area.",
        declined: "Rejected",
        subeventRegistration: "Sub-event registration",
        subeventRegistrationMsg: "One or more sub-event registrations are waiting for approval for this attendee's registration. If the registration is not approved, the attendee cannot access the relevant sub-event.",
        waitingAbstractApproval: "Waiting for abstract approval",
        waitingAbstractApprovalMsg: "Attendee has unfinished papers. Please control that the necessary process is done.",
        review: "Review",
        activationCode: "Activation code",
        activationNotUse: "This code has not been used yet",
        activeDate: "Activated on {0}.",
        activationCodeSure: "Are you sure to renew the activation code?",
        participantInformation: "Attendee information",
        registrationInformation: "Registration information",
        yesRefreshBtn: "Yes, refresh",
        cancelBtn: "Cancel",
        registrationInfo: {
          registrationForm: "Registration form",
          registrationDate: "Date of registration",
          registrationPackage: "Registration package",
          price: "Price",
          daysOfParticipation: "Participation days",
          noRestrictions: "No restrictions",
          registrationDate: "Registration date"
        },
        subEvent: "Sub-event",
        attendeeSubEventRegistration: {
          subEvent: "Sub-event",
          source: "Source",
          package: "Package: <b>Standard attendance package</b>",
          registrationDate: "Registration date",
          confirmationStatus: "Confirmation status",
          confirm: "Confirm",
          reject: "Reject",
          noSubEventRegistration: "There are no sub-event registrations.",
          seeDetails: "See sub-event details",
          edit: "Edit",
          delete: "Delete",
          deleteSure: "Are you sure to delete this registration?"
        },
        attendeeProductRegistration: {
          noProduct: "There are no product registrations"
        },
        accompany: "Companion",

        attendeeAccom: {
          nameSurname: "Name, surname",
          price: "Price",
          registrationDate: "Registration date",
          linkedPayment: "Payment",
          noAffiliatePayments: "There are no payments",
          confirmationStatus: "Confirmation status",
          confirm: "Confirm",
          reject: "Reject",
          deleteSure: "Are you sure to delete this registration?",
          deleteYes: "Yes, delete",
          cancel: "Cancel",
          noAttendee: "There is no companion attendee registration.",
          seeDetails: "See attendee details",
          edit: "Edit",
          delete: "Delete",
          deleteSure: "Are you sure you want to delete this registration?"
        },
        attendeeServices: {
          service: "Service",
          price: "Price",
          registrationDate: "Registration date",
          linkedPayment: "Payment",
          confirmationStatus: "Confirmation status",
          confirm: "Confirm",
          reject: "Reject",
          seeDetails: "See additional service details",

          noRegistration: "There is no additional service registration."
        },

        notices: "Abstracts",
        add: "Add",
        AttendeeAbstract: {
          a: "b",
          waitingDecision: "Waiting for decision",
          accept: "Accept",
          conditionalAccept: "Conditionally accept",
          reject: "Reject",
          deleteSure: "Are you sure you to delete this registration?",
          deleteYes: "Yes, delete",
          cancel: "Cancel"
        },
        pendingPayments: "Pending payments",
        addPayment: "Add payment",
        a: "b",
        attendeeAwaitingPayments: {
          createProforma: "Create proforma"
        },
        payments: "Payments",
        attendeePayments: {
          paymentId: "Payment ID",
          paymentMethod: "Payment method",
          amount: "Amount",
          registrationDate: "Registration date",
          paymentStatus: "Payment status",
          confirm: "Confirm",
          reject: "Reject",
          noRegistration: "There is no payment record.",
          seeDetails: "See payment details"
        },
        actions: "Actions",
        attendeeActions: {
          messages: "Messages",
          checkin: "Check-in",
          cardPrinting: "Badge printing",
          certificates: "Certificates",
          promotion: "Promotion",
          title: "Title",
          status: "Status",
          registrationDate: "Registration date",
          dateByWho: "Edited by {0}.",
          system: "system",
          noVouchers: "No vouchers have been sent to this attendee.",
          description: "Description",
          standName: "Booth name",
          noCheckinRegistration: "There are no check-in records.",
          card: "Card",
          pressCard: "Press card",
          description: "Description",
          noCards: "No badge has been printed to this attendee.",
          certificate: "Certificate",
          firstPlaceCertificate: "Leader certificate",
          noCertifacete: "No certificate was sent to this attendee.",
          show: "View",
          promotion: "Promotion",
          piece: "piece",
          noPromotion: "This attendee has not received any promotions."
        },
        notes: "Notes",
        attendeeNotes: {
          note: "Note",
          registrationDate: "Registration date",
          noNote: "Note added.",
          createBy: "Created by {0}."
        },
        cardPrint: "Badge print",
        printCardComp: {
          cardDesign: "Badge design",
          description: "Description",
          lostCard: "Lost badge",
          printerError: "Printer error",
          problemTag: "Problem tag",
          incorrectRegistration: "Incorrect registration",
          informationUpdate: "Information update",
          close: "Close",
          print: "Print",
          checkAndPrint: "Print and check-in",
          infoMsg: "Card printing has started",
          moreThanOne: "You must select at least one attendee"
        },

        addNote: "Add note",
        addParticipantNote: {
          yourNote: "Your note"
        },
        takePhoto: "Take a photo",
        editParticipant: "Edit attendee",
        addProxyParticipant: "Add proxy attendee"
      }
    },
    attendeeList: {
      participant: {
        choose: "Process for {0} selected registrations",
        sendVoucher: "Send voucher",
        sendCertificate: "Send certificate",

        batchPrint: "Badge printing batch",
        clearSelected: "Clear selected",
        deleteSelected: "Delete selected",
        export: "export {0} draft",
        addAttendee: "Add Attendee",
        editAttendee: "Edit Attendee",
        detailsAttendee: "Attendee details",
        close: "Close",
        AttendeeNumber: "Attendee number",
        nameSurname: "Name & Surname",
        registrationDate: "Registration Date",
        filterMsg: "Narrow your search with the filter options.",
        questions: "Questions",

        search: {
          searchMsg: "You can copy the printer number for the printer you will connect from the print agent.",
          addRegistrationCoupon: "Add registration",
          search: "Search",
          addParticipant: "Add attendee",
          editParticipant: "Edit attendee",
          printerId: "Printer ID",
          noFound: "The attendee was not found.",
          searchRegister: "Registration search"
        },

        addUpdateParticipant: {
          shoppingCardInfo: "For informational purposes only.",
          registrationType: "Registration type",
          registrationTypeMsg: "To add a new attendee, you must specify the registration type first.",
          registrationForm: "Registration form",
          registrationFormMsg: "Choose the registration form to add the attendee. You cannot view the registration types without selecting a registration form.",
          registrationPackage: "Registration package",
          registrationPackageMsg: 'Select the package to which you want to add the attendee. You can use the <b>"Manual"</b> option to add attendees regardless of any package.',
          participationDay: "Participation day",
          participationDayMsg: 'The package you have selected is the <b>"One-day"</b> participation package. Select the day the attendee is scheduled to attend.',
          segmentation: "Segmentation",
          segmentationMsg: "Choose a tag to include the attendee. This part cannot be changed if the package has any defined tag.",
          subSegmentation: "Sub segmentation",
          subSegmentationMsg: "Choose a tag to include the attendee.",
          attendeeInformation: "Attendee information",
          attendeeInformationMsg: "To add a new attendee, you must fill in the registration information.",
          photo: "Photo",
          takePhoto: "Take a photo",
          photoDragMsg: "Drag or <em>click to install.</em>",
          photoSizeMsg: "<b>png or jpg</b> files with a size less than <b>5 mb</b>.",
          subEvents: "Sub-events",
          subEventsMsg: "You can register the attendee in any sub-event.",
          addRegistration: "Add registration",
          subEvent: "Sub-event",
          summary: "Summary",
          summaryMsg: "You can see the attendees' registration summary. You can add companions and additional services to the attendee.",
          addCompanion: "Add companion",
          addService: "Add service",
          serviceName: "Service name",
          unitPrice: "Unit price",
          piece: "Piece",
          amount: "Amount",
          registration: "Registration",
          companion: "Companion",
          additionalService: "Additional service",
          additionalProduct: "Products",
          additionalProductMsg: "You can add any product for this attendee",
          close: "Close",
          save: "Save",
          titlesNoSubEventMsg: "No sub-event registration added.",
          titlesNoProductMsg: "No product registration added.",
          productName: "Product Name",
          titlesAddEditSubEvent: "Add/edit sub-event",
          titlesAddEditProduct: "Add/edit Product",
          titlesAddEditCompanion: "Add/edit companion",
          titlesAddEditServices: "Add/edit services",
          addDialogs: {
            subEvent: "Sub activity",
            close: "Close",
            delete: "Delete",
            save: "Save",
            selectService: "Select Service"
          }
        }
      },
      a: "b",
      a: "b",
      a: "b"
    },
    segmentations: {
      addGroup: "Add group",
      editTag: "Edit tag",
      deleteTag: "Delete tag",
      addTag: "Add tag",
      tagAddUpdate: {
        selectGroup: "Select group",
        selectGroupMsg: "The group you select defines the attendee group that the tag will be included in.",
        updateGroupList: "It updates the group list.",
        title: "Title",
        titleMsg: "Enter a name for your tag.",
        color: "Color",
        colorMsg: "Select a color for this tag",
        stock: "Stock",
        stockMsg: "You can set the attendee limit for this segment. Zero means unlimited.",
        additionalServiceBased: "Include in a additional service",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
        cardPrinting: "Badge printing",
        cardPrintingMsg: "When you turn this option off, attendees with this tag cannot receive a printed badge when they come to the registration desk.",
        close: "Close",
        delete: "Delete",
        save: "Save",
        titlePlaceholder: "E.g: VIP guests",
        chooseLabelColorPlaceholder: "Choose tag color"
      },
      groupAddUpdate: {
        title: "Title",
        titleMsg: "Enter a title as the group name.",
        titlePlaceholder: "E.g: VIP guests",
        color: "Color",
        colorMsg: "Select a color for this grup",
        colorPlaceholder: "Choose group color",
        note: "Note",
        noteMsg: "You can take some notes for you and our team.",
        notePlaceholder: "Enter note...",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        view: "Show",
        viewMsg: "When you turn this option off, attendees cannot reach this content in apps and other digital platforms.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    }
  },
  components: {
    abstract: {
      tabs: {
        dialog: {
          presentationType: {
            title: "Title",
            details: "Details",
            delete: "Delete",
            close: "Close",
            save: "Save"
          },
          submissionDialog: {
            title: "Başlık",
            details: "Detaylar",
            delete: "Sil",
            close: "Kapat",
            save: "Kaydet"
          }
        },
        abstractAuthors: {
          instruction: "Instructions for authors",
          instructionMsg: "Provide a brief submission guideline for authors.",
          instructionMsgSpecial: "The instruction will only be displayed for those who wishes to submit an abstract.",
          authors: "Authors",
          authorsMsg: "Provide a brief submission guideline for authors.",
          title: "Title",
          save: "Save"
        },
        abstractDetailSettings: {
          abstractTitle: "Abstract title",
          abstractTitleMsg: "Abstract title is a mandatory field and must be completed when submitting an abstract.",
          title: "Title",
          maxWordLimit: "Max. word limit",
          keywords: "Keywords",
          keywordsMsg: "Allow authors to add keywords.",
          limit: "Limit",
          references: "References",
          referencesMsg: "Allow authors to add references.",
          save: "Save"
        },
        abstractEvaluationSettings: {
          guide: "Guidelines for reviewers",
          guideMsg: "Provide an evaluation guideline to reviewers.",
          scoreFormat: "Reviewers scoring format",
          scoreFormatMsg: "Choose a scoring format for reviewers to evaluate submissions.",
          accepted: "Accepted",
          conditionallyAccepted: "Conditionally accepted",
          reject: "Reject",
          reviewSettings: "Judge evaluation settings",
          reviewSettingsMsg: "Choose review settings for reviewers to evaluate submissions.",
          enablePeerReview: "Enable private review",
          enablePeerReviewMsg: "Prevent reviewers and authors from accessing the applicant's identity.",
          otherReviewersScore: "Show other reviewers' scores",
          otherReviewersScoreMsg: "Allow reviewers to see other reviewers' scores.",
          sendReminder: "Send evaluation reminder to reviewers",
          sendReminderMsg: "A notification email will be sent to the reviewer when there are submissions pending consideration.",
          lockAbstract: "Lock abstract evaluation system",
          lockAbstractMsg: "Prevent reviewers evaluate abstracts.",
          save: "Save"
        },
        abstractGeneralSettings: {
          notificationCollect: "Abstract collection method",
          notificationCollectMsg: "Define how to collect your abstracts.",
          textUpload: "Text upload",
          fileUpload: "File upload",
          label: "Title",
          placeholder: "Placeholder",
          hint: "Hint",
          wordLimit: "Word limit",
          wordLimitMsg: "Define minimum and maximum word limits.",
          minChar: "Min. character allowed",
          maxChar: "Max. character allowed",
          allowImageUpload: "Allow image upload",
          allowImageUploadMsg: "Define minimum and maximum word limits.",
          maxSize: "Max. file size(mb)",
          allowFile: "Allowed file types",
          imgFile: "Image files",
          textFile: "Text files",
          spreadsheetFile: "Spreadsheet files",
          presentationFile: "Presentation files",
          compressedFile: "Compressed files",
          save: "Save"
        },
        abstractPackages: {
          abstractPackages: "Abstract packages",
          abstractPackagesMsg: "Select the registration form and packages where the abstract system will be activated. After the registration is received, a separate redirect will be sent for the abstract submission.",
          save: "Save"
        },
        abstractRules: {
          limitSubmisson: "Limit the submission period",
          limitSubmissonMsg: "Limit submission period by entering a start date and a deadline.",
          startDate: "Start date",
          endDate: "End date",
          limitNumberSubmission: "Limit the number of submissions ",
          limitNumberSubmissionMsg: "Limit the number of submissions according to registration or presentation types.",
          maxValueParticipant: "Max. value per attendee",
          maxValueParticipantMsg: "Limit the number of submissions per registration type or enter 0 for hiding.",
          presentationType: "Presentation type",
          limitNumber: "Limit number",
          save: "Save",
          pickDay: "Select a day"
        },
        abstractSubmission: {
          submission: "Submission topics",
          submissionMsg: "Define conference topics and enable authors to submit their abstracts accordingly",
          title: "Title",
          topicsTracks: "Topics ",
          addTopicTrack: "Add topic",
          presentationType: "Presentation type",
          presentationTypeMsg: 'Create presentation types such as "Oral" or "Poster" and enable authors to submit their abstracts accordingly.',
          title: "Title",
          presentationType: "Presentation type",
          show: "Show",
          addPresentationType: "Add presentation type",
          topicTrackDetails: "Topic details",
          presentationTypesDetails: "Presentation type details",
          save: "Save"
        }
      }
    },
    automatedmessages: {
      automatedLogs: {
        filter: "Filter",
        search: "Search",
        draft: "Draft",
        status: "Status",
        close: "Close",
        reset: "Reset",
        participant: "Attendee",
        messageNameTypeSubject: "Message name, type, subject",
        postMessageStatusAction: "Message, status, action",
        participantNo: "Attendee no",
        all: "All"
      },
      controlPointLogs: {
        filter: "Filter",
        search: "Search",
        controlType: "Control type",
        status: "Status",
        close: "Close",
        reset: "Reset",
        participant: "Attendee",
        controlType: "Control type",
        checkpoint: "Control point",
        status: "Status",
        date: "Date",
        download: "Download",
        participantNo: "Attendee no",
        all: "All"
      },
      programReminder: {
        defaultEn: "Default (English)",
        tr: "Turkish",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        show: "View",
        showMsg: "When you turn off this option, attendees cannot access and view this content through the mobile application and other digital platforms.",
        close: "Close",
        save: "Save",
        subject: "Subject",
        variables: "Variables",
        notification: "Notification"
      },
      voucherAddUpdate: {
        defaultEn: "Default (English)",
        tr: "Turkish",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        show: "View",
        showMsg: "When you turn this option off, attendees cannot access or view this content via mobile applications and other digital platforms.",
        submission: "Submission",
        submissionMsg: "When you turn off this option, users cannot view this content on the transaction menus.",
        showQr: "Show QR code",
        showQrMsg: "When this option is hidden, quick login options with QR code are turned off. This action is not recommended for onsite events.",
        showLocation: "Show location and address information",
        showLocationMsg: "When you hide location and address information, attendees cannot access details about event location. This action is not recommended for onsite events.",
        showMobileDownload: "Show mobile app download links",
        showMobileDownloadMsg: "When you hide mobile app download links, attendees may have trouble downloading event mobile apps. It is recommended to keep this option turned on for an interactive event experience.",
        showWebLogin: "Show web application login links",
        showWebLoginMsg: "When you hide web application login links, attendees may have trouble making it to the event on the web. For an interactive event experience, it is recommended to keep the option turned on.",
        showActivation: "Show activation code",
        showActivationMsg: "When you hide the activation code, attendees cannot join online events. On onsite events, attendees cannot use mobile applications.",
        showQuicklogin: "Show quick login links",
        showQuickloginMsg: "When you hide the quick login link, attendees cannot use the automatic activation option. It is not recommended to turn this option off for online events.",
        showOrganizerInfo: "Show organizer info",
        showOrganizerInfoMsg: "Shows/hides organization information.",
        close: "Close",
        delete: "Delete",
        save: "Save",

        title: "Title",
        titleMsg: "It is displayed as the message title.",
        replyEmail: "Reply email address",
        replyEmailMsg: "This e-mail address will be displayed as the “from” e-mail.",
        subject: "Subject",
        subjectMsg: "It is displayed as the subject of your message.",
        variables: "Variables",
        variablesMsg: "You can specify the variables you want to use in the message customized according to each attendee.",
        message: "Message",
        messageMsg: "Create the content of your message."
      }
    },
    dashboard: {
      summary: "Summary",
      abstract: {
        notice: "Abstract",
        accepted: "Accepted",
        conditionally: "Conditionally accepted",
        rejected: "Rejected",
        waiting: "Waiting"
      },
      certificate: {
        digitalCertificate: "Digital certificate analysis",
        certificateExpiry: "Certificate expiry date:",
        certificate: "Certificate",
        submitted: "Submitted",
        forwarded: "Forwarded",
        readed: "Read",
        queue: "Pending",
        error: "Error"
      },
      content: {
        cantAccess: "You cannot access this feature.",
        cantAccessMsg: "Your plan does not support this feature. You can upgrade your plan by choosing a suitable one to use it.",
        upgrade: "Upgrade",
        posts: "Posts",
        sessionReview: "Session reviews",
        review: "review",
        contents: "Contents",
        networkingRooms: "Networking rooms",
        subActivity: "Sub-event analysis",
        productActivity: "Product analysis",
        postType: "Post type",
        sharing: "Share",
        comment: "Comment",
        like: "Like",
        program: "Program",
        average: "Average",
        review: "Review",
        speakers: "Speakers",
        content: "Content",
        room: "Room",
        reports: "Reports",
        subEvent: "Sub-event",
        product: "Product",
        confirmation: "Confirmation",
        waiting: "Waiting",
        rejection: "Rejection",
        total: "Attendees",
        seeLess: "See less",
        seeAll: "See all"
      },
      live: {
        hall: "Hall",
        onlineMeasurement: "Online",
        watchTime: "Watch time",
        broadcastTime: "Duration",
        minute: "mins.",
        recordingMessage: "Registered files are automatically deleted after 30 days.",
        totalFiles: "{0} files have been recorded"
      },
      notification: {
        voucherEmails: "Voucher emails",
        voucherSms: "Voucher SMSs",
        automaticEmails: "Automatic emails",
        notificationEmails: "Notification emails"
      },
      onsite: {
        total: "total",
        unique: "unique",
        checkin: "Check-in analysis",
        automaticCheckin: "Automatic check-in analysis",
        standCheckin: "Booth check-in analysis",
        accessControl: "Access control analysis",
        cardPrinting: "Badge printing analysis",
        promotionalDistribution: "Promotional product distribution analysis",
        placeholderAll: "All"
      },
      overview: {
        participantSegmentation: "Attendee segmentation",
        labelTotal: "{0} tags, {1} attendees in total"
      },
      registration: {
        piece: "piece",
        seeLess: "See less",
        seeAll: "See all",
        paymentAnalysis: "Payment analysis",
        packages: "Packages",
        additionalServices: "Additional services",
        couponCodes: "Coupon codes",
        expectedParticipation: "Expected participation analysis",

        paymentType: "Payment type",
        today: "Today",
        last1: "Last 1 month",
        last3: "Last 3 months",
        allTime: "All time",
        package: "Package",
        stockUsage: "Stock / Usage",
        amount: "Amount",
        service: "Service",
        reminder: "Remainder",
        codeGroup: "Code group",
        totalDiscont: "Total discount",
        day: "Day"
      }
    },
    eventinfo: {
      pageModuleUpdate: {
        defaultEn: "Default (English)",
        tr: "Turkish",
        content: "Content",
        contentMsg: "Identifies the contents of the module.",
        settings: "Settings",
        settingsMsg: "You can make any changes to the current settings related to the content.",
        show: "Show",
        showMsg: "When you turn this option off, attendees and visitors cannot access or view the content. ",
        close: "Close",
        delete: "Delete",
        save: "Save"
      }
    },
    eventprogram: {
      eventProgramRate: {
        filter: "Filter",
        search: "Search",
        searchPlaceholder: "Search...",
        participantNumber: "Attendee no",
        participantNumberPlaceholder: "Attendee no",
        reset: "Reset",
        participant: "Attendee",
        evaluation: "Rating",
        status: "Status",
        confirm: "Confirm",
        reject: "Reject",
        close: "Close"
      }
    },
    participants: {
      addPictureCamera: {
        close: "Close",
        delete: "Delete",
        save: "Save",
        take: "Take",
        again: "Take again"
      },
      sendVoucher: {
        draftSelection: "Select draft",
        certificateSelection: "Select certificate",
        voucherType: "Voucher type",
        sendingStart: "Voucher delivery started.",
        sendingCertificateStart: "Certificate delivery started.",
        sendingStartInfo: "Please do not close this screen during the process.",
        sendingEnd: "Voucher delivery has been completed.",
        sendingCertificateEnd: "Certificate delivery has been completed.",
        sendingCertificate: "Certificate delivery has been completed.",
        startSending: "Start sending"
      }
    },

    registerForm: {
      questionEdit: {
        dateFormat: "Date Format",
        label: "Title",
        tag: "Tag",
        defineQuestion: "Defines the question.",
        placeholder: "Sample text",
        placeholderMsg: "Identifies the sample text in the answer introduction part of the question.",
        hint: "Hint",
        hintMsg: "Identifies the hint text in the answer field.",
        initialValue: "Initial value",
        initialValueMsg: "Identifies the initial numeric value of the question.",
        minValue: "Minimum value",
        minValueMsg: "Identifies the minimum numeric value that the question can take.",
        maxValue: "Maximum value",
        maxValueMsg: "Identifies the maximum numeric value that the question can take.",
        step: "Step",
        stepMsg: "Defines how many numerical values   the question can increment or decrement at each step.",
        textTransform: "Edit by format",
        textTransformMsg: "Defines the process of editing the answer text to the question according to the specified format.",
        minCharAllowed: "Minimum allowed character",
        minCharAllowedMsg: "Defines the minimum number of words the question can take.",
        maxCharAllowed: "Maximum allowed characters",
        maxCharAllowedMsg: "Defines the maximum number of words the question can take.",
        minLineAllowed: "Minimum allowed lines",
        minLineAllowedMsg: "Defines the maximum number of lines of the answer text to the question.",
        color: "Color",
        colorMsg: "Define the colour specified for the question.",
        domainRestriction: "Domain restriction",
        domainRestrictionMsg: 'Identifies the email domain name restrictions of the question. For example, when <b>"@holacon.com"</b> domain name restriction is defined, it will only accept responses from the defined domain name.',
        countryCodeRestriction: "Country code restriction",
        countryCodeRestrictionMsg: 'Identifies the phone country code restrictions of the question. For example, when <b>"+90"</b> code restriction is defined, only numbered answers containing Turkey country code will be accepted.',
        maxFileSize: "Maximum size",
        maxFileSizeMsg: 'Defines the file upload limit in <b>"Megabytes"</b> of the answer the question can take.',
        addSearchBox: "Add search box",
        multipleSelection: "Allow multiple selections",
        fileType: "Allowed file types",
        fileTypeMsg: "Defines the file format of the answer to the question.",
        imageFiles: "Image files",
        textFiles: "Text files",
        spreadsheetFiles: "Spreadsheet files",
        presentationFiles: "Presentation files",
        compressedFiles: "Compressed files",
        showOptions: "Display options",
        showOptionsMsg: "You can organize the display options of this question according to packages.",
        show: "Show",
        required: "Required",
        hide: "Hide",
        showOptions: "Display options",
        showOptionsMsg: "You can organize the display options of this question according to services.",
        close: "Close",
        delete: "Delete",
        save: "Save"
      },

      questionLibrary: {
        addQuestion: "Add question",
        label: "Label",
        questionType: "Question type",
        required: "Required",
        show: "Show",
        singleLineText: "Single line text",
        singleLineTextMsg: "Get the answer as a single line text.",
        informationBanner: "Info block",
        informationBannerMsg: "You can provide any additional information.",
        multiLineText: "Multiline text",
        multiLineTextMsg: "Get answers as multiline text.",
        multipleChoiceQuestion: "Multiple choice question",
        multipleChoiceQuestionMsg: "Collect answers as multiple choices.",
        singleChoiceQuestion: "Single choice",
        singleChoiceQuestionMsg: "Collect answers as a single choice.",
        predefinedQuestions: "Predefined questions",
        photo: "Photo",
        title: "Title",
        instituon: "Institution",
        company: "Company",
        department: "Department",
        school: "School",
        mobilePhone: "Mobile phone",
        workPhone: "Work phone",
        country: "Country",
        state: "State",
        city: "City",
        postalCode: "Zip code",
        addressLine: "Address line",
        hesCode: "HES code",
        customQuestions: "Custom questions",
        email: "Email",
        phoneNumber: "Phone number",
        fileUpload: "File upload",
        number: "Number",
        selectDropdown: "Select dropdown list",
        datepicker: "Date selection",
        timepicker: "Time selection",
        richTextEditor: "HTML editor",
        informationQuestions: "Info questions",
        slider: "Slider",
        rate: "Vote",
        emotionRate: "Emotion rating scale",
        infoBlock: "Info block"
      },
      recursiveQuestion: {
        deleteSure: "Are you sure to delete?",
        copySure: "Are you sure to delete?",
        editQuestion: "Edit question",
        deleteQuestion: "Delete",
        copyQuestion: "Copy Question",
        yes: "Yes",
        cancel: "Cancel",
        addSubQuestion: "Add sub-question",
        deleteOption: "Delete",
        discardSubQuestion: "Delete sub-questions",
        editQuestion: "Edit",
        addQuestion: "Add",
        addOption: "Add option",

        questions: "Questions",
        options: "Options",
        expand: "Expand",
        collapse: "Collapse",
        label: "Title",
        questionType: "Question type",
        required: "Required",
        show: "View",

        customLineQuestion: "Custom questions",
        singleLineText: "Single line text",
        multiLineText: "Multiline Text",
        email: "Email",
        phoneNumber: "Phone number",
        fileUpload: "File upload",
        number: "Number",
        multipleChoiceQuestion: "Multiple choice question",
        singleChoiceQuestion: "Single choice question",
        selectDropdown: "Select dropdown",
        datePicker: "Select date",
        timePicker: "Select time",
        richTextEditor: "Text editor",
        informationQuestions: "Information questions",
        slider: "Slider",
        rate: "Rating",
        emotionRate: "Emotion rating scale",
        infoBlock: "Info block"
      }
    },
    socialhub: {
      comment: {
        openContatRegistration: "Open attendee registration",
        editComment: "Edit comment",
        deleteComment: "Delete comment",
        cancel: "Cancel",
        comment: "Comment",
        reply: "Reply",
        noMoreLikes: "There are no other likes.",
        noLikes: "There are no likes yet.",
        like: "Like",
        justEdited: "just edited.",
        openContactRecord: "Open attendee registration",
        editReply: "Edit reply",
        deleteReply: "Delete reply",
        justNow: "just now",
        loadOldComments: "Upload previous comments"
      },
      createPost: {
        post: "Post",
        createsContent: "Creates a content and announcement type post.",
        vote: "Vote",
        picMsg: "Please upload a 640x480 photo.",

        createVote: "Creates a live voting post",
        survey: "Survey",
        createSurvey: "Creates a survey post",
        subject: "Subject",
        defineSubjectContent: "Defines a topic for the content",
        liveSession: "Live session",
        allowsPost: "Allows the post to be shared in a specific live session. The shared content will only appear in the feed of people who attended that live session.",
        sendNotification: "Send notification",
        contentNotification: "The content is sent as a notification to app users' phones.",
        draft: "Draft",
        savePost: "Saves the post as a draft so you can edit and share it later.",
        title: "Title",
        defineTitle: "Defines the title of the survey",
        save: "Save",
        share: "Share",
        placeholderSelect: "Select...",
        announcementError: "The posts to be sent as announcements and notifications cannot be saved as drafts."
      },
      postCard: {
        edited: "edited",
        draft: "Draft",
        rejected: "Rejected",
        waiting: "Waiting",
        openContactRegistration: "Open attendee registration",
        publishDraft: "Publish draft",
        confirmShipment: "Confirm post",
        rejectPost: "Reject post",
        reflectVoting: "Start screen mirroring",
        stopvoting: "Stop screen mirroring",
        downloadResult: "Download results",
        endVoting: "End live voting",
        endPoll: "End survey",
        restartVoting: "Restart live voting",
        restartPoll: "Restart survey",
        sendReminderNotification: "Send reminder notification",
        editPost: "Edit post",
        deletePost: "Delete post",
        subject: "Subject:",
        bigSubject: "SUBJECT",
        almostTwelveQuestion: "It consists of 12 questions.",
        next: "Next",
        joinedPeopleVoting: "person participated in the live voting.",
        joinedPeoplePoll: "person participated in the survey.",
        peopleTalkingAboutIt: "people are talking about it.",
        comment: "Comment",
        doComment: "Comment",
        deleteComment: "Delete comment",
        youAndPeopleLiked: "You and {0} people liked it.",
        peopleLiked: "people liked.",
        noMoreComment: "There are no other comments.",
        noComment: "No comments have been posted yet.",
        hideComment: "Hide comments",
        hideReply: "Hide replies",
        pollEnded: "Live voting completed.",
        vote: "Vote",
        youJoinedPoll: "You have participated in this survey.",
        join: "Join",
        cancel: "Cancel",
        reply: "Reply",
        youLikedIt: "You liked",
        like: "Like",
        continueReading: "Continue reading",
        votingEnded: "Live voting has been closed.",
        surveyQuestionNumber: "The survey consists of approximately {0} questions.",
        loadMore: "Load more",
        pleaseWrite: "Please fill in the comment box.",
        pleaseSelectToDelete: "Please specify the content type to delete",
        likeListUploadMsg: "Likes List Uploaded"
      },
      socialHub: {
        stream: "Feed",
        drafts: "Drafts",
        settings: "Settings"
      },
      socialHubDrafts: {
        noMorePosts: "There are no other posts.",
        noPostShared: "No posts have been shared yet."
      },
      socialHubFeed: {
        newPost: "New post",
        search: "Search",
        sort: "Sort by",
        postType: "Post type",
        subject: "Subject",
        status: "Status",
        clearFilter: "Clear filter",
        noMorePosts: "There are no other posts.",
        noPostShared: "No posts have been shared yet.",

        placeholderSearch: "Search...",
        placeholderSelect: "Select..."
      },
      socialHubSettings: {
        subjects: "Subjects",
        addSubject: "Add subject",
        color: "Color",
        show: "View",
        deleteTopic: "Delete topic",
        socialHubSettings: "Social hub settings",
        autoPublish: "Approve posts automatically",
        autoApproval: "Send posts for confirmation first.",
        closeNew: "Close to new posts",
        otherTransactions: "Other transactions",
        clearSocialHub: "Clear social hub<span>You can clear all content shared on the social hub. This action cannot be undone.",
        deleteSelected: "Delete selected contents",

        enterTopicTitle: "Type a topic title...",
        placeholderSelect: "Select...",
        deleteSure: "Are you sure to delete?"
      }
    },
    eventWrapper: {
      createPost: "Create post",
      socialHub: "Social hub",
      createPost: "Create post",
      export: "Export",
      import: "Import",
      sendVoucher: "Send voucher",
      paymentDetail: "Payment detail",
      participantDetails: "Attendee details",
      close: "Close"
    },
    excelImportAndExport: {
      registrationForm: "Registration form",
      placeholderSelect: "Select...",
      transferCompleted: "Transfer completed.",
      errorList: "Error list",
      close: "Close",
      clear: "Clear",
      save: "Save",
      infoMsg1: "You are about to export data.",
      infoMsg2: "Please do not close the screen during the process...",
      total: "Total",
      start: "Start transfer"
    },
    homeMenu: {
      createOrganization: "Create organization",
      organizationType: "Organization type"
    },
    itemInfo: {
      lastUser: "The user who made the last transaction",
      creation: "Created:",
      update: "Updated: "
    },
    liveSessionAddUpdate: {
      close: "Close",
      delete: "Delete",
      save: "Save"
    },
    participantAddOrUpdate: {
      auths: "Authorized users",
      authsMsg: "You can make any changes to the current settings related to the content.",
      addAuth: "Add a new authorized user",
      add: "Add",
      speaker: "Speaker",
      task: "Task",
      show: "View",
      settings: "Settings",
      settingsMsg: "You can make any changes to the current settings related to the content.",
      show: "View",
      showMsg: "When you turn this option off, attendees cannot view and access this content through the mobile application and other digital platforms.",
      accessControl: "Access control automation",
      accessControlMsg: "When you activate access control automation for this hall, you can perform access control operations at digital control points.",
      noController: 'There is no controller defined for this networking room. To define a controller, you can create a new controller from the "control points" section and define it for this networking room.',
      goControlCenter: "Go to control points",

      placeholderSelectAuth: "Select authorized user"
    },
    seatingManagement: {
      placeholderSearchAttendee: "Search for attendees...",
      noOther: "There are no other attendees",
      noFound: "No attendees were found.",
      tableNumbers: "{1} people placed on table {0}",
      updating: "Updating",
      createTable: "Create table",
      person: "person",
      delete: "Delete",
      table: "Table"
    },
    subEventRecords: {
      filter: "Filter",
      subEvents: "Sub-events",
      status: "Status",
      participant: "Attendee",
      subEventRecords: "Sub-event registrations",
      confirm: "Confirm",
      reject: "Reject",

      placeholderAll: "All"
    },
    vimeoLiveSessionAddUpdate: {
      coverPhoto: "Cover photo",
      photoSize: "You can use a 500x135 px photo.",
      manage: "Manage stages"
    },
    userMini: {
      userNotFound: "User Not Found"
    }
  },
  pages: {
    event: {
      abstractManagement: {
        abstractSettings: "Notification settings"
      },
      eventDashboard: {
        overview: "Overview",
        registrationSale: "Registration & Sales",
        notices: "Abstracts",
        liveEvent: "Live event",
        contentAnalysis: "Content analysis",
        certificate: "Certificate",
        messageAnalysis: "Message analysis",
        onsiteAnalysis: "Onsite analysis",
        updateTime: "Data updated {0}.",
        overview: "Overview",
        excelDownload: "Download Excel",
        notices: "Abstracts",
        liveEventExperience: "Virtual event",
        contentAnalysis: "Content analysis",
        digitalCertificate: "Digital certificate",
        onsiteAnalysis: "Onsite analysis"
      }
    },
    newAccount: {
      welcome: "Welcome",
      cantCreate: "You have not created an event yet.",
      createFirstEvenet: "Create your first event.",
      create: "CREATE",
      activateCouponCode: "If you have a coupon code, you can use it.",
      activate: "ACTIVATE",
      placeholderTypeEvent: "Enter the event name.",
      placeholderTypeCoupon: "Enter your coupon code."
    },
    organisationAttendees: {
      attendees: "Attendees",
      pleaseSelectEvent: "Please select an event",
      attendee: "Attendee",
      uniqValue: "Unique value"
    }
  },
  archiveModal: {
    fileName: "File name",
    session: "Session",
    date: "Date",
    fileSize: "Size",
    close: "Close"
  },
  redeemModal: {
    title: "Redeem Code",
    text: "You can boost account with redeem codes!",
    buttonText: "Submit",
    placeHolder: "Your redeem code"
  },
  commonMessages: {
    changesNeedsToSave: "You have changes that needs to be saved."
  },
  b2b: {
    start_time: "Start time",
    end_time: "End time",
    appointmentMinute: "Duration (mins)",
    minute: "minutes",
    text: "You can activate the B2B matching feature to allow attendees to create appointments."
  },
  // generic messages could be added here
  generic: {
    standard: "Standard",
    uploadText: "Drop file here or <em>click to upload</em>",
    sendCertificate: "Send certificate",
    newOption: "New Option",
    status: "Status",
    generatingPleaseWait: "Generating, plase wait.",
    recaptcha: "Please complete the recaptcha verification.",
    picMsg: "Upload a 500x500 image.",
    nothingFound: "There is nothing to show here.",
    deleteSure: "Are you sure to delete this?",
    deleteYes: "Yes, delete",
    operationCancel: "Cancel",
    hide: "Hide"
  }
};

export default en;



// WEBPACK FOOTER //
// ./src/language/en.js